/* tslint:disable */
/* eslint-disable */
/**
 * Radianse Rules API - .Net 6
 * <b>Build:</b>Radianse.App.Rules_main_2023.10.11.1
 *
 * The version of the OpenAPI document: UserApi_V1
 * Contact: support@radianse.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { Configuration } from "./configuration";
import globalAxios, {
  AxiosPromise,
  AxiosInstance,
  AxiosRequestConfig,
} from "axios";
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from "./common";
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  RequestArgs,
  BaseAPI,
  RequiredError,
} from "./base";

/**
 * ClientTree type
 * @export
 * @enum {string}
 */

export const IClientTreeType = {
  Customer: "Customer",
  Tenant: "Tenant",
  Group: "Group",
} as const;

export type IClientTreeType =
  typeof IClientTreeType[keyof typeof IClientTreeType];

/**
 * Rules that apply to a customer
 * @export
 * @interface ICustomerConfiguration
 */
export interface ICustomerConfiguration {
  /**
   * Cosmos id
   * @type {string}
   * @memberof ICustomerConfiguration
   */
  id: string;
  /**
   * Category hard coded to Rules
   * @type {string}
   * @memberof ICustomerConfiguration
   */
  category?: string | null;
  /**
   * Stored with constant subcategory for operations needed in Radianse.Api.Availability
   * @type {string}
   * @memberof ICustomerConfiguration
   */
  subCategory?: string | null;
  /**
   * PartitionKey = customerId
   * @type {string}
   * @memberof ICustomerConfiguration
   */
  partitionKey: string;
  /**
   * Id of the configuration on the RuleConfiguration endpoint
   * @type {string}
   * @memberof ICustomerConfiguration
   */
  ruleConfigurationId: string;
  /**
   * Rule requirements. Must pass the rules defined by this requirement type before being allowed to enter the stage
   * @type {string}
   * @memberof ICustomerConfiguration
   */
  requirementTypeId?: string | null;
  /**
   * @type {IRuleStageType}
   * @memberof ICustomerConfiguration
   */
  stage: IRuleStageType;
  /**
   * Deleted
   * @type {boolean}
   * @memberof ICustomerConfiguration
   */
  deleted?: boolean | null;
}
/**
 *
 * @export
 * @interface ICustomerConfigurationIRadianseResult
 */
export interface ICustomerConfigurationIRadianseResult {
  /**
   * @type {number}
   * @memberof ICustomerConfigurationIRadianseResult
   */
  count?: number | null;
  /**
   * @type {ICustomerConfiguration}
   * @memberof ICustomerConfigurationIRadianseResult
   */
  data?: ICustomerConfiguration;
  /**
   * @type {string}
   * @memberof ICustomerConfigurationIRadianseResult
   */
  detail: string;
  /**
   * @type {{ [key: string]: Array<string>; }}
   * @memberof ICustomerConfigurationIRadianseResult
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   * @type {string}
   * @memberof ICustomerConfigurationIRadianseResult
   */
  instance?: string | null;
  /**
   * @type {number}
   * @memberof ICustomerConfigurationIRadianseResult
   */
  status?: number;
  /**
   * @type {boolean}
   * @memberof ICustomerConfigurationIRadianseResult
   */
  success?: boolean;
  /**
   * @type {string}
   * @memberof ICustomerConfigurationIRadianseResult
   */
  title?: string;
  /**
   * @type {string}
   * @memberof ICustomerConfigurationIRadianseResult
   */
  traceId?: string | null;
  /**
   * @type {string}
   * @memberof ICustomerConfigurationIRadianseResult
   */
  type?: string | null;
  /**
   * @type {string}
   * @memberof ICustomerConfigurationIRadianseResult
   */
  continuationToken?: string | null;
}
/**
 * Required inputs into a document
 * @export
 * @interface IDocumentTemplateRequirements
 */
export interface IDocumentTemplateRequirements {
  /**
   * Document ID
   * @type {string}
   * @memberof IDocumentTemplateRequirements
   */
  documentId?: string;
  /**
   * Handlebars expression
   * @type {Array<IHandlebarsType>}
   * @memberof IDocumentTemplateRequirements
   */
  requiredData?: Array<IHandlebarsType>;
}
/**
 * Document with a weighted value to determine if requirement number of documents has been submitted
 * @export
 * @interface IDocumentWeighted
 */
export interface IDocumentWeighted {
  /**
   * The id to store the document under. This must be unique.
   * @type {string}
   * @memberof IDocumentWeighted
   */
  id?: string | null;
  /**
   * Name
   * @type {string}
   * @memberof IDocumentWeighted
   */
  name?: string;
  /**
   * Description of the document required which may be used by UI
   * @type {string}
   * @memberof IDocumentWeighted
   */
  description?: string | null;
  /**
   * The value to set to determine if requirement number of documents has been submitted
   * @type {number}
   * @memberof IDocumentWeighted
   */
  weightedValue?: number;
}
/**
 * Rule for documents required to pass rule
 * @export
 * @interface IDocumentWeightedRule
 */
export interface IDocumentWeightedRule {
  /**
   * A description to describe the requirements of the documents which are required.
   * @type {string}
   * @memberof IDocumentWeightedRule
   */
  description?: string;
  /**
   * Each document is given a weighted value
   * @type {number}
   * @memberof IDocumentWeightedRule
   */
  weightedTotalValue?: number;
  /**
   * List of documents and the weighted value
   * @type {Array<IDocumentWeighted>}
   * @memberof IDocumentWeightedRule
   */
  documents?: Array<IDocumentWeighted>;
}
/**
 * Configure rules to apply to customer, tenant, events, or equipment
 * @export
 * @interface IElementConfigurationVm
 */
export interface IElementConfigurationVm {
  /**
   * Id of the configuration on the RuleConfiguration endpoint
   * @type {string}
   * @memberof IElementConfigurationVm
   */
  ruleConfigurationId: string;
  /**
   * Rule requirements. Must pass the rules defined by this requirement type before being allowed to enter the stage
   * @type {string}
   * @memberof IElementConfigurationVm
   */
  requirementTypeId?: string | null;
  /**
   * @type {IRuleStageType}
   * @memberof IElementConfigurationVm
   */
  stage?: IRuleStageType;
}
/**
 * Type of rule configuration
 * @export
 * @enum {string}
 */

export const IElementRuleConfigType = {
  Customer: "Customer",
  Tenant: "Tenant",
  Events: "Events",
  Equipment: "Equipment",
} as const;

export type IElementRuleConfigType =
  typeof IElementRuleConfigType[keyof typeof IElementRuleConfigType];

/**
 *
 * @export
 * @interface IEquipmentConfiguration
 */
export interface IEquipmentConfiguration {
  /**
   *
   * @type {string}
   * @memberof IEquipmentConfiguration
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof IEquipmentConfiguration
   */
  category?: string | null;
  /**
   * Stored with constant subcategory for operations needed in Radianse.Api.Availability
   * @type {string}
   * @memberof IEquipmentConfiguration
   */
  subCategory?: string | null;
  /**
   * PartitionKey = tenantId
   * @type {string}
   * @memberof IEquipmentConfiguration
   */
  partitionKey: string;
  /**
   *
   * @type {string}
   * @memberof IEquipmentConfiguration
   */
  equipmentId: string;
  /**
   * Id of the configuration on the RuleConfiguration endpoint
   * @type {string}
   * @memberof IEquipmentConfiguration
   */
  ruleConfigurationId: string;
  /**
   * @type {IRuleStageType}
   * @memberof IEquipmentConfiguration
   */
  stage: IRuleStageType;
  /**
   *
   * @type {string}
   * @memberof IEquipmentConfiguration
   */
  tenantId: string;
  /**
   *
   * @type {boolean}
   * @memberof IEquipmentConfiguration
   */
  deleted?: boolean | null;
}
/**
 *
 * @export
 * @interface IEquipmentConfigurationIRadianseResult
 */
export interface IEquipmentConfigurationIRadianseResult {
  /**
   * @type {number}
   * @memberof IEquipmentConfigurationIRadianseResult
   */
  count?: number | null;
  /**
   * @type {IEquipmentConfiguration}
   * @memberof IEquipmentConfigurationIRadianseResult
   */
  data?: IEquipmentConfiguration;
  /**
   * @type {string}
   * @memberof IEquipmentConfigurationIRadianseResult
   */
  detail: string;
  /**
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IEquipmentConfigurationIRadianseResult
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   * @type {string}
   * @memberof IEquipmentConfigurationIRadianseResult
   */
  instance?: string | null;
  /**
   * @type {number}
   * @memberof IEquipmentConfigurationIRadianseResult
   */
  status?: number;
  /**
   * @type {boolean}
   * @memberof IEquipmentConfigurationIRadianseResult
   */
  success?: boolean;
  /**
   * @type {string}
   * @memberof IEquipmentConfigurationIRadianseResult
   */
  title?: string;
  /**
   * @type {string}
   * @memberof IEquipmentConfigurationIRadianseResult
   */
  traceId?: string | null;
  /**
   * @type {string}
   * @memberof IEquipmentConfigurationIRadianseResult
   */
  type?: string | null;
  /**
   * @type {string}
   * @memberof IEquipmentConfigurationIRadianseResult
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface IEquipmentConfigurationListIRadianseResult
 */
export interface IEquipmentConfigurationListIRadianseResult {
  /**
   * @type {number}
   * @memberof IEquipmentConfigurationListIRadianseResult
   */
  count?: number | null;
  /**
   * @type {Array<IEquipmentConfiguration>}
   * @memberof IEquipmentConfigurationListIRadianseResult
   */
  data?: Array<IEquipmentConfiguration> | null;
  /**
   * @type {string}
   * @memberof IEquipmentConfigurationListIRadianseResult
   */
  detail: string;
  /**
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IEquipmentConfigurationListIRadianseResult
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   * @type {string}
   * @memberof IEquipmentConfigurationListIRadianseResult
   */
  instance?: string | null;
  /**
   * @type {number}
   * @memberof IEquipmentConfigurationListIRadianseResult
   */
  status?: number;
  /**
   * @type {boolean}
   * @memberof IEquipmentConfigurationListIRadianseResult
   */
  success?: boolean;
  /**
   * @type {string}
   * @memberof IEquipmentConfigurationListIRadianseResult
   */
  title?: string;
  /**
   * @type {string}
   * @memberof IEquipmentConfigurationListIRadianseResult
   */
  traceId?: string | null;
  /**
   * @type {string}
   * @memberof IEquipmentConfigurationListIRadianseResult
   */
  type?: string | null;
  /**
   * @type {string}
   * @memberof IEquipmentConfigurationListIRadianseResult
   */
  continuationToken?: string | null;
}
/**
 * Apply rules to an events
 * @export
 * @interface IEventsConfiguration
 */
export interface IEventsConfiguration {
  /**
   * ID
   * @type {string}
   * @memberof IEventsConfiguration
   */
  id: string;
  /**
   * Category
   * @type {string}
   * @memberof IEventsConfiguration
   */
  category?: string | null;
  /**
   * Stored with constant subcategory for operations needed in Radianse.Api.Availability
   * @type {string}
   * @memberof IEventsConfiguration
   */
  subCategory?: string | null;
  /**
   * PartitionKey = tenantId
   * @type {string}
   * @memberof IEventsConfiguration
   */
  partitionKey: string;
  /**
   * Events ID to apply the rules to
   * @type {string}
   * @memberof IEventsConfiguration
   */
  eventsId: string;
  /**
   * Rule configuration ID
   * @type {string}
   * @memberof IEventsConfiguration
   */
  ruleConfigurationId: string;
  /**
   * @type {IRuleStageType}
   * @memberof IEventsConfiguration
   */
  stage: IRuleStageType;
  /**
   * Tenant ID
   * @type {string}
   * @memberof IEventsConfiguration
   */
  tenantId: string;
  /**
   * Deleted
   * @type {boolean}
   * @memberof IEventsConfiguration
   */
  deleted?: boolean | null;
}
/**
 *
 * @export
 * @interface IEventsConfigurationIRadianseResult
 */
export interface IEventsConfigurationIRadianseResult {
  /**
   * @type {number}
   * @memberof IEventsConfigurationIRadianseResult
   */
  count?: number | null;
  /**
   * @type {IEventsConfiguration}
   * @memberof IEventsConfigurationIRadianseResult
   */
  data?: IEventsConfiguration;
  /**
   * @type {string}
   * @memberof IEventsConfigurationIRadianseResult
   */
  detail: string;
  /**
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IEventsConfigurationIRadianseResult
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   * @type {string}
   * @memberof IEventsConfigurationIRadianseResult
   */
  instance?: string | null;
  /**
   * @type {number}
   * @memberof IEventsConfigurationIRadianseResult
   */
  status?: number;
  /**
   * @type {boolean}
   * @memberof IEventsConfigurationIRadianseResult
   */
  success?: boolean;
  /**
   * @type {string}
   * @memberof IEventsConfigurationIRadianseResult
   */
  title?: string;
  /**
   * @type {string}
   * @memberof IEventsConfigurationIRadianseResult
   */
  traceId?: string | null;
  /**
   * @type {string}
   * @memberof IEventsConfigurationIRadianseResult
   */
  type?: string | null;
  /**
   * @type {string}
   * @memberof IEventsConfigurationIRadianseResult
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface IEventsConfigurationListRadianseResult
 */
export interface IEventsConfigurationListRadianseResult {
  /**
   * @type {number}
   * @memberof IEventsConfigurationListRadianseResult
   */
  count?: number | null;
  /**
   * @type {Array<IEventsConfiguration>}
   * @memberof IEventsConfigurationListRadianseResult
   */
  data?: Array<IEventsConfiguration> | null;
  /**
   * @type {string}
   * @memberof IEventsConfigurationListRadianseResult
   */
  detail: string;
  /**
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IEventsConfigurationListRadianseResult
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   * @type {string}
   * @memberof IEventsConfigurationListRadianseResult
   */
  instance?: string | null;
  /**
   * @type {number}
   * @memberof IEventsConfigurationListRadianseResult
   */
  status?: number;
  /**
   * @type {boolean}
   * @memberof IEventsConfigurationListRadianseResult
   */
  success?: boolean;
  /**
   * @type {string}
   * @memberof IEventsConfigurationListRadianseResult
   */
  timeStamp?: string;
  /**
   * @type {string}
   * @memberof IEventsConfigurationListRadianseResult
   */
  title?: string;
  /**
   * @type {string}
   * @memberof IEventsConfigurationListRadianseResult
   */
  traceId?: string | null;
  /**
   * @type {string}
   * @memberof IEventsConfigurationListRadianseResult
   */
  type?: string | null;
  /**
   * @type {string}
   * @memberof IEventsConfigurationListRadianseResult
   */
  continuationToken?: string | null;
}
/**
 * Data types
 * @export
 * @enum {string}
 */

export const IHandlebarsDataType = {
  String: "String",
  Signature: "Signature",
  CurrentDateTime: "CurrentDateTime",
} as const;

export type IHandlebarsDataType =
  typeof IHandlebarsDataType[keyof typeof IHandlebarsDataType];

/**
 * The expression names and types in a handlebars template
 * @export
 * @interface IHandlebarsType
 */
export interface IHandlebarsType {
  /**
   * The expression in the handlebars template
   * @type {string}
   * @memberof IHandlebarsType
   */
  expressionName?: string;
  /**
   * Display Name
   * @type {string}
   * @memberof IHandlebarsType
   */
  displayName?: string;
  /**
   * @type {IHandlebarsDataType}
   * @memberof IHandlebarsType
   */
  type?: IHandlebarsDataType;
}
/**
 *
 * @export
 * @interface IIRadianseRequestContext
 */
export interface IIRadianseRequestContext {
  /**
   * @type {string}
   * @memberof IIRadianseRequestContext
   */
  clientAccessToken?: string;
  /**
   * @type {string}
   * @memberof IIRadianseRequestContext
   */
  acceptLanguage?: string | null;
  /**
   * @type {string}
   * @memberof IIRadianseRequestContext
   */
  ipAddress?: string;
  /**
   * @type {boolean}
   * @memberof IIRadianseRequestContext
   */
  isUserRequest?: boolean;
  /**
   * @type {string}
   * @memberof IIRadianseRequestContext
   */
  scopeToCustomerId?: string;
  /**
   * @type {string}
   * @memberof IIRadianseRequestContext
   */
  scopeToGroupId?: string | null;
  /**
   * @type {string}
   * @memberof IIRadianseRequestContext
   */
  scopeToTenantId?: string | null;
  /**
   * @type {string}
   * @memberof IIRadianseRequestContext
   */
  userAccessToken?: string;
  /**
   * @type {string}
   * @memberof IIRadianseRequestContext
   */
  detail?: string | null;
  /**
   * @type {string}
   * @memberof IIRadianseRequestContext
   */
  identityProfileId?: string;
  /**
   * @type {Array<string>}
   * @memberof IIRadianseRequestContext
   */
  clientRoles?: Array<string>;
  /**
   * @type {Array<string>}
   * @memberof IIRadianseRequestContext
   */
  customerRoles?: Array<string>;
  /**
   * @type {Array<string>}
   * @memberof IIRadianseRequestContext
   */
  groupRoles?: Array<string>;
  /**
   * @type {Array<string>}
   * @memberof IIRadianseRequestContext
   */
  tenantRoles?: Array<string>;
  /**
   * @type {Array<string>}
   * @memberof IIRadianseRequestContext
   */
  customerPermissions?: Array<string> | null;
  /**
   * @type {Array<string>}
   * @memberof IIRadianseRequestContext
   */
  groupPermissions?: Array<string> | null;
  /**
   * @type {Array<string>}
   * @memberof IIRadianseRequestContext
   */
  tenantPermissions?: Array<string> | null;
}
/**
 * Class with Id and Name
 * @export
 * @interface IIdAndName
 */
export interface IIdAndName {
  /**
   * ID
   * @type {string}
   * @memberof IIdAndName
   */
  id?: string;
  /**
   * Name
   * @type {string}
   * @memberof IIdAndName
   */
  name?: string;
}
/**
 *
 * @export
 * @interface IIdAndNameListIRadianseResult
 */
export interface IIdAndNameListIRadianseResult {
  /**
   * @type {number}
   * @memberof IIdAndNameListIRadianseResult
   */
  count?: number | null;
  /**
   * @type {Array<IIdAndName>}
   * @memberof IIdAndNameListIRadianseResult
   */
  data?: Array<IIdAndName> | null;
  /**
   * @type {string}
   * @memberof IIdAndNameListIRadianseResult
   */
  detail: string;
  /**
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IIdAndNameListIRadianseResult
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   * @type {string}
   * @memberof IIdAndNameListIRadianseResult
   */
  instance?: string | null;
  /**
   * @type {number}
   * @memberof IIdAndNameListIRadianseResult
   */
  status?: number;
  /**
   * @type {boolean}
   * @memberof IIdAndNameListIRadianseResult
   */
  success?: boolean;
  /**
   * @type {string}
   * @memberof IIdAndNameListIRadianseResult
   */
  title?: string;
  /**
   * @type {string}
   * @memberof IIdAndNameListIRadianseResult
   */
  traceId?: string | null;
  /**
   * @type {string}
   * @memberof IIdAndNameListIRadianseResult
   */
  type?: string | null;
  /**
   * @type {string}
   * @memberof IIdAndNameListIRadianseResult
   */
  continuationToken?: string | null;
}
/**
 * Boolean logical operators
 * @export
 * @enum {string}
 */

export const ILogicalOperatorType = {
  And: "And",
  Or: "Or",
} as const;

export type ILogicalOperatorType =
  typeof ILogicalOperatorType[keyof typeof ILogicalOperatorType];

/**
 *
 * @export
 * @interface IMetaDataInfo
 */
export interface IMetaDataInfo {
  /**
   * Dynamic data
   * @type {any}
   * @memberof IMetaDataInfo
   */
  data?: any;
}
/**
 * Override a rule to allow one to schedule
 * @export
 * @interface IOverRideValidation
 */
export interface IOverRideValidation {
  /**
   * RuleEvaluator Id
   * @type {string}
   * @memberof IOverRideValidation
   */
  id: string;
  /**
   * Reason for override
   * @type {string}
   * @memberof IOverRideValidation
   */
  reason: string;
  /**
   * Name of the client (user, app, etc) authorized to override
   * @type {string}
   * @memberof IOverRideValidation
   */
  clientName: string;
}
/**
 *
 * @export
 * @interface IProblemDetails
 */
export interface IProblemDetails {
  [key: string]: any;

  /**
   * @type {string}
   * @memberof IProblemDetails
   */
  type?: string | null;
  /**
   * @type {string}
   * @memberof IProblemDetails
   */
  title?: string | null;
  /**
   * @type {number}
   * @memberof IProblemDetails
   */
  status?: number | null;
  /**
   * @type {string}
   * @memberof IProblemDetails
   */
  detail?: string | null;
  /**
   * @type {string}
   * @memberof IProblemDetails
   */
  instance?: string | null;
}
/**
 * Operator type for query operations
 * @export
 * @enum {string}
 */

export const IQueryOperatorType = {
  Equals: "Equals",
  LessThan: "LessThan",
  LessThanOrEquals: "LessThanOrEquals",
  GreaterThan: "GreaterThan",
  GreaterThanOrEquals: "GreaterThanOrEquals",
  NotEquals: "NotEquals",
  NotNull: "NotNull",
  IsNull: "IsNull",
  IsDefined: "IsDefined",
  NotDefined: "NotDefined",
  IsNotNullAndIsDefined: "IsNotNullAndIsDefined",
  IsNullOrNotIsDefined: "IsNullOrNotIsDefined",
} as const;

export type IQueryOperatorType =
  typeof IQueryOperatorType[keyof typeof IQueryOperatorType];

/**
 * Class to support number of schedules allowed per time period.
 * @export
 * @interface IRateLimited
 */
export interface IRateLimited {
  /**
   * Time period in minutes
   * @type {number}
   * @memberof IRateLimited
   */
  restrictionLimitInMinutes: number;
  /**
   * How many times allowed to schedule
   * @type {number}
   * @memberof IRateLimited
   */
  restrictionLimitFrequency: number;
}
/**
 *
 * @export
 * @interface IRequirementType
 */
export interface IRequirementType {
  /**
   *
   * @type {string}
   * @memberof IRequirementType
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof IRequirementType
   */
  category?: string | null;
  /**
   * Stored with constant subcategory for operations needed in Radianse.Api.Availability
   * @type {string}
   * @memberof IRequirementType
   */
  subCategory?: string | null;
  /**
   * PartitionKey = RequirementType
   * @type {string}
   * @memberof IRequirementType
   */
  partitionKey: string;
  /**
   *
   * @type {string}
   * @memberof IRequirementType
   */
  name: string;
  /**
   *
   * @type {Array<string>}
   * @memberof IRequirementType
   */
  ruleGroups: Array<string>;
  /**
   *
   * @type {string}
   * @memberof IRequirementType
   */
  ruleManagerId: string;
  /**
   *
   * @type {boolean}
   * @memberof IRequirementType
   */
  deleted?: boolean | null;
}
/**
 *
 * @export
 * @interface IRequirementTypeIEnumerableIRadianseResult
 */
export interface IRequirementTypeIEnumerableIRadianseResult {
  /**
   * @type {number}
   * @memberof IRequirementTypeIEnumerableIRadianseResult
   */
  count?: number | null;
  /**
   * @type {Array<IRequirementType>}
   * @memberof IRequirementTypeIEnumerableIRadianseResult
   */
  data?: Array<IRequirementType> | null;
  /**
   * @type {string}
   * @memberof IRequirementTypeIEnumerableIRadianseResult
   */
  detail: string;
  /**
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IRequirementTypeIEnumerableIRadianseResult
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   * @type {string}
   * @memberof IRequirementTypeIEnumerableIRadianseResult
   */
  instance?: string | null;
  /**
   * @type {number}
   * @memberof IRequirementTypeIEnumerableIRadianseResult
   */
  status?: number;
  /**
   * @type {boolean}
   * @memberof IRequirementTypeIEnumerableIRadianseResult
   */
  success?: boolean;
  /**
   * @type {string}
   * @memberof IRequirementTypeIEnumerableIRadianseResult
   */
  title?: string;
  /**
   * @type {string}
   * @memberof IRequirementTypeIEnumerableIRadianseResult
   */
  traceId?: string | null;
  /**
   * @type {string}
   * @memberof IRequirementTypeIEnumerableIRadianseResult
   */
  type?: string | null;
  /**
   * @type {string}
   * @memberof IRequirementTypeIEnumerableIRadianseResult
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface IRequirementTypeIRadianseResult
 */
export interface IRequirementTypeIRadianseResult {
  /**
   * @type {number}
   * @memberof IRequirementTypeIRadianseResult
   */
  count?: number | null;
  /**
   * @type {IRequirementType}
   * @memberof IRequirementTypeIRadianseResult
   */
  data?: IRequirementType;
  /**
   * @type {string}
   * @memberof IRequirementTypeIRadianseResult
   */
  detail: string;
  /**
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IRequirementTypeIRadianseResult
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   * @type {string}
   * @memberof IRequirementTypeIRadianseResult
   */
  instance?: string | null;
  /**
   * @type {number}
   * @memberof IRequirementTypeIRadianseResult
   */
  status?: number;
  /**
   * @type {boolean}
   * @memberof IRequirementTypeIRadianseResult
   */
  success?: boolean;
  /**
   * @type {string}
   * @memberof IRequirementTypeIRadianseResult
   */
  title?: string;
  /**
   * @type {string}
   * @memberof IRequirementTypeIRadianseResult
   */
  traceId?: string | null;
  /**
   * @type {string}
   * @memberof IRequirementTypeIRadianseResult
   */
  type?: string | null;
  /**
   * @type {string}
   * @memberof IRequirementTypeIRadianseResult
   */
  continuationToken?: string | null;
}
/**
 * Requirement type
 * @export
 * @interface IRequirementTypeVm
 */
export interface IRequirementTypeVm {
  /**
   * Name of the requirement type
   * @type {string}
   * @memberof IRequirementTypeVm
   */
  name: string;
  /**
   * Rule groups
   * @type {Array<string>}
   * @memberof IRequirementTypeVm
   */
  ruleGroups: Array<string>;
  /**
   * Id of the rule manager
   * @type {string}
   * @memberof IRequirementTypeVm
   */
  ruleManagerId: string;
}
/**
 *
 * @export
 * @interface IRequirementValidationResult
 */
export interface IRequirementValidationResult {
  /**
   * ID
   * @type {string}
   * @memberof IRequirementValidationResult
   */
  id: string;
  /**
   * Rules
   * @type {string}
   * @memberof IRequirementValidationResult
   */
  category?: string | null;
  /**
   * Stored with constant subcategory for operations needed in Radianse.Api.Availability
   * @type {string}
   * @memberof IRequirementValidationResult
   */
  subCategory?: string | null;
  /**
   * PartitionKey
   * @type {string}
   * @memberof IRequirementValidationResult
   */
  partitionKey: string;
  /**
   * Rules was evaluated at this UTC time
   * @type {string}
   * @memberof IRequirementValidationResult
   */
  evaluatedAtUtc?: string;
  /**
   * Requirement type id
   * @type {string}
   * @memberof IRequirementValidationResult
   */
  requirementTypeId: string;
  /**
   * Pending rules
   * @type {Array<string>}
   * @memberof IRequirementValidationResult
   */
  pendingRules: Array<string>;
  /**
   * List of rule failures
   * @type {Array<string>}
   * @memberof IRequirementValidationResult
   */
  ruleFailures: Array<string>;
  /**
   * Details
   * @type {Array<IRulesExecutionDetail>}
   * @memberof IRequirementValidationResult
   */
  details: Array<IRulesExecutionDetail>;
  /**
   * Success or failure
   * @type {boolean}
   * @memberof IRequirementValidationResult
   */
  succeeded?: boolean;
  /**
   * Overide the result of running the rules
   * @type {boolean}
   * @memberof IRequirementValidationResult
   */
  overRideResult?: boolean;
  /**
   * Person or token ID who did the override
   * @type {string}
   * @memberof IRequirementValidationResult
   */
  overRiddenById?: string;
  /**
   * Person or token name who did the override
   * @type {string}
   * @memberof IRequirementValidationResult
   */
  overRiddenByName?: string;
  /**
   * Note
   * @type {string}
   * @memberof IRequirementValidationResult
   */
  note?: string;
  /**
   * Rules token was redeemed
   * @type {boolean}
   * @memberof IRequirementValidationResult
   */
  redeemed?: boolean;
  /**
   * Tenant Id
   * @type {string}
   * @memberof IRequirementValidationResult
   */
  tenantId: string;
  /**
   * CustomerId
   * @type {string}
   * @memberof IRequirementValidationResult
   */
  customerId: string;
  /**
   * @type {IRuleEvaluatorVm}
   * @memberof IRequirementValidationResult
   */
  request?: IRuleEvaluatorVm;
  /**
   * Deleted
   * @type {boolean}
   * @memberof IRequirementValidationResult
   */
  deleted?: boolean | null;
}
/**
 *
 * @export
 * @interface IRequirementValidationResultIRadianseResult
 */
export interface IRequirementValidationResultIRadianseResult {
  /**
   * @type {number}
   * @memberof IRequirementValidationResultIRadianseResult
   */
  count?: number | null;
  /**
   * @type {IRequirementValidationResult}
   * @memberof IRequirementValidationResultIRadianseResult
   */
  data?: IRequirementValidationResult;
  /**
   * @type {string}
   * @memberof IRequirementValidationResultIRadianseResult
   */
  detail: string;
  /**
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IRequirementValidationResultIRadianseResult
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   * @type {string}
   * @memberof IRequirementValidationResultIRadianseResult
   */
  instance?: string | null;
  /**
   * @type {number}
   * @memberof IRequirementValidationResultIRadianseResult
   */
  status?: number;
  /**
   * @type {boolean}
   * @memberof IRequirementValidationResultIRadianseResult
   */
  success?: boolean;
  /**
   * @type {string}
   * @memberof IRequirementValidationResultIRadianseResult
   */
  title?: string;
  /**
   * @type {string}
   * @memberof IRequirementValidationResultIRadianseResult
   */
  traceId?: string | null;
  /**
   * @type {string}
   * @memberof IRequirementValidationResultIRadianseResult
   */
  type?: string | null;
  /**
   * @type {string}
   * @memberof IRequirementValidationResultIRadianseResult
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface IRequirementValidationResultListIRadianseResult
 */
export interface IRequirementValidationResultListIRadianseResult {
  /**
   * @type {number}
   * @memberof IRequirementValidationResultListIRadianseResult
   */
  count?: number | null;
  /**
   * @type {Array<IRequirementValidationResult>}
   * @memberof IRequirementValidationResultListIRadianseResult
   */
  data?: Array<IRequirementValidationResult> | null;
  /**
   * @type {string}
   * @memberof IRequirementValidationResultListIRadianseResult
   */
  detail: string;
  /**
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IRequirementValidationResultListIRadianseResult
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   * @type {string}
   * @memberof IRequirementValidationResultListIRadianseResult
   */
  instance?: string | null;
  /**
   * @type {number}
   * @memberof IRequirementValidationResultListIRadianseResult
   */
  status?: number;
  /**
   * @type {boolean}
   * @memberof IRequirementValidationResultListIRadianseResult
   */
  success?: boolean;
  /**
   * @type {string}
   * @memberof IRequirementValidationResultListIRadianseResult
   */
  title?: string;
  /**
   * @type {string}
   * @memberof IRequirementValidationResultListIRadianseResult
   */
  traceId?: string | null;
  /**
   * @type {string}
   * @memberof IRequirementValidationResultListIRadianseResult
   */
  type?: string | null;
  /**
   * @type {string}
   * @memberof IRequirementValidationResultListIRadianseResult
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface IRequirementValidationResultVm
 */
export interface IRequirementValidationResultVm {
  /**
   * Rules was evaluated at this UTC time
   * @type {string}
   * @memberof IRequirementValidationResultVm
   */
  evaluatedAtUtc?: string;
  /**
   * Requirement type id
   * @type {string}
   * @memberof IRequirementValidationResultVm
   */
  requirementTypeId: string;
  /**
   * Pending rules
   * @type {Array<string>}
   * @memberof IRequirementValidationResultVm
   */
  pendingRules: Array<string>;
  /**
   * Details
   * @type {Array<IRulesExecutionDetail>}
   * @memberof IRequirementValidationResultVm
   */
  details: Array<IRulesExecutionDetail>;
  /**
   * Success or failure
   * @type {boolean}
   * @memberof IRequirementValidationResultVm
   */
  succeeded?: boolean;
  /**
   * Overide the result of running the rules
   * @type {boolean}
   * @memberof IRequirementValidationResultVm
   */
  overRideResult?: boolean;
  /**
   * Person or token ID who did the override
   * @type {string}
   * @memberof IRequirementValidationResultVm
   */
  overRiddenById?: string;
  /**
   * Person or token name who did the override
   * @type {string}
   * @memberof IRequirementValidationResultVm
   */
  overRiddenByName?: string;
  /**
   * Note
   * @type {string}
   * @memberof IRequirementValidationResultVm
   */
  note?: string;
  /**
   * @type {IRuleEvaluatorVm}
   * @memberof IRequirementValidationResultVm
   */
  request?: IRuleEvaluatorVm;
}
/**
 *
 * @export
 * @interface IRuleCacheStatus
 */
export interface IRuleCacheStatus {
  /**
   * @type {string}
   * @memberof IRuleCacheStatus
   */
  category?: string;
  /**
   * @type {string}
   * @memberof IRuleCacheStatus
   */
  subCategory?: string;
  /**
   * @type {string}
   * @memberof IRuleCacheStatus
   */
  id?: string | null;
  /**
   * @type {string}
   * @memberof IRuleCacheStatus
   */
  partitionKey?: string;
  /**
   * @type {string}
   * @memberof IRuleCacheStatus
   */
  lastUpdate?: string;
  /**
   * @type {string}
   * @memberof IRuleCacheStatus
   */
  lastRebuild?: string;
  /**
   * @type {string}
   * @memberof IRuleCacheStatus
   */
  hubConnectionState?: string;
}
/**
 *
 * @export
 * @interface IRuleCacheStatusIRadianseResult
 */
export interface IRuleCacheStatusIRadianseResult {
  /**
   * @type {number}
   * @memberof IRuleCacheStatusIRadianseResult
   */
  count?: number | null;
  /**
   * @type {IRuleCacheStatus}
   * @memberof IRuleCacheStatusIRadianseResult
   */
  data?: IRuleCacheStatus;
  /**
   * @type {string}
   * @memberof IRuleCacheStatusIRadianseResult
   */
  detail: string;
  /**
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IRuleCacheStatusIRadianseResult
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   * @type {string}
   * @memberof IRuleCacheStatusIRadianseResult
   */
  instance?: string | null;
  /**
   * @type {number}
   * @memberof IRuleCacheStatusIRadianseResult
   */
  status?: number;
  /**
   * @type {boolean}
   * @memberof IRuleCacheStatusIRadianseResult
   */
  success?: boolean;
  /**
   * @type {string}
   * @memberof IRuleCacheStatusIRadianseResult
   */
  title?: string;
  /**
   * @type {string}
   * @memberof IRuleCacheStatusIRadianseResult
   */
  traceId?: string | null;
  /**
   * @type {string}
   * @memberof IRuleCacheStatusIRadianseResult
   */
  type?: string | null;
  /**
   * @type {string}
   * @memberof IRuleCacheStatusIRadianseResult
   */
  continuationToken?: string | null;
}
/**
 * Required operator rule
 * @export
 * @interface IRuleConfigRequiredOperator
 */
export interface IRuleConfigRequiredOperator {
  /**
   * Is required?
   * @type {boolean}
   * @memberof IRuleConfigRequiredOperator
   */
  required?: boolean;
}
/**
 * Rule configuration scoped to customer.
 * @export
 * @interface IRuleConfiguration
 */
export interface IRuleConfiguration {
  /**
   * ID
   * @type {string}
   * @memberof IRuleConfiguration
   */
  id: string;
  /**
   * PartitionKey = RuleConfiguration
   * @type {string}
   * @memberof IRuleConfiguration
   */
  partitionKey: string;
  /**
   * Category
   * @type {string}
   * @memberof IRuleConfiguration
   */
  category?: string | null;
  /**
   * Stored with constant subcategory for operations needed in Radianse.Api.Availability
   * @type {string}
   * @memberof IRuleConfiguration
   */
  subCategory?: string | null;
  /**
   * Name
   * @type {string}
   * @memberof IRuleConfiguration
   */
  name: string;
  /**
   * Minimum Age
   * @type {number}
   * @memberof IRuleConfiguration
   */
  minimumAge?: number | null;
  /**
   * Allowed member types
   * @type {Array<string>}
   * @memberof IRuleConfiguration
   */
  allowedMembershipTypes?: Array<string> | null;
  /**
   * Miles from location
   * @type {number}
   * @memberof IRuleConfiguration
   */
  milesFromLocation?: number | null;
  /**
   * Required documents
   * @type {Array<string>}
   * @memberof IRuleConfiguration
   */
  requiredDocuments?: Array<string> | null;
  /**
   * Conditionally required documents
   * @type {Array<IDocumentWeightedRule>}
   * @memberof IRuleConfiguration
   */
  conditionallyRequiredDocuments?: Array<IDocumentWeightedRule> | null;
  /**
   * Time restrictions
   * @type {{ [key: string]: ITimeRestriction; }}
   * @memberof IRuleConfiguration
   */
  timeRestrictions?: { [key: string]: ITimeRestriction } | null;
  /**
   * @type {IRateLimited}
   * @memberof IRuleConfiguration
   */
  rateLimited?: IRateLimited;
  /**
   * @type {IRuleServicesConfig}
   * @memberof IRuleConfiguration
   */
  servicesConfig?: IRuleServicesConfig;
  /**
   * Dynamic rules
   * @type {Array<IRuleDynamicConfig>}
   * @memberof IRuleConfiguration
   */
  dynamicRules?: Array<IRuleDynamicConfig> | null;
  /**
   * Required inputs for a document
   * @type {Array<IDocumentTemplateRequirements>}
   * @memberof IRuleConfiguration
   */
  templateRequirements?: Array<IDocumentTemplateRequirements> | null;
  /**
   * @type {IRuleConfigRequiredOperator}
   * @memberof IRuleConfiguration
   */
  operator?: IRuleConfigRequiredOperator;
  /**
   * Deleted
   * @type {boolean}
   * @memberof IRuleConfiguration
   */
  deleted?: boolean | null;
}
/**
 *
 * @export
 * @interface IRuleConfigurationIRadianseResult
 */
export interface IRuleConfigurationIRadianseResult {
  /**
   * @type {number}
   * @memberof IRuleConfigurationIRadianseResult
   */
  count?: number | null;
  /**
   * @type {IRuleConfiguration}
   * @memberof IRuleConfigurationIRadianseResult
   */
  data?: IRuleConfiguration;
  /**
   * @type {string}
   * @memberof IRuleConfigurationIRadianseResult
   */
  detail: string;
  /**
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IRuleConfigurationIRadianseResult
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   * @type {string}
   * @memberof IRuleConfigurationIRadianseResult
   */
  instance?: string | null;
  /**
   * @type {number}
   * @memberof IRuleConfigurationIRadianseResult
   */
  status?: number;
  /**
   * @type {boolean}
   * @memberof IRuleConfigurationIRadianseResult
   */
  success?: boolean;
  /**
   * @type {string}
   * @memberof IRuleConfigurationIRadianseResult
   */
  title?: string;
  /**
   * @type {string}
   * @memberof IRuleConfigurationIRadianseResult
   */
  traceId?: string | null;
  /**
   * @type {string}
   * @memberof IRuleConfigurationIRadianseResult
   */
  type?: string | null;
  /**
   * @type {string}
   * @memberof IRuleConfigurationIRadianseResult
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface IRuleConfigurationListIRadianseResult
 */
export interface IRuleConfigurationListIRadianseResult {
  /**
   * @type {number}
   * @memberof IRuleConfigurationListIRadianseResult
   */
  count?: number | null;
  /**
   * @type {Array<IRuleConfiguration>}
   * @memberof IRuleConfigurationListIRadianseResult
   */
  data?: Array<IRuleConfiguration> | null;
  /**
   * @type {string}
   * @memberof IRuleConfigurationListIRadianseResult
   */
  detail: string;
  /**
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IRuleConfigurationListIRadianseResult
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   * @type {string}
   * @memberof IRuleConfigurationListIRadianseResult
   */
  instance?: string | null;
  /**
   * @type {number}
   * @memberof IRuleConfigurationListIRadianseResult
   */
  status?: number;
  /**
   * @type {boolean}
   * @memberof IRuleConfigurationListIRadianseResult
   */
  success?: boolean;
  /**
   * @type {string}
   * @memberof IRuleConfigurationListIRadianseResult
   */
  title?: string;
  /**
   * @type {string}
   * @memberof IRuleConfigurationListIRadianseResult
   */
  traceId?: string | null;
  /**
   * @type {string}
   * @memberof IRuleConfigurationListIRadianseResult
   */
  type?: string | null;
  /**
   * @type {string}
   * @memberof IRuleConfigurationListIRadianseResult
   */
  continuationToken?: string | null;
}
/**
 * Rule configurations
 * @export
 * @interface IRuleConfigurationStagesVm
 */
export interface IRuleConfigurationStagesVm {
  /**
   * Rule configurations per stage
   * @type {{ [key: string]: IRuleConfigurationVm; }}
   * @memberof IRuleConfigurationStagesVm
   */
  ruleConfigurations?: { [key: string]: IRuleConfigurationVm };
}
/**
 *
 * @export
 * @interface IRuleConfigurationVm
 */
export interface IRuleConfigurationVm {
  /**
   * Rule configuration name
   * @type {string}
   * @memberof IRuleConfigurationVm
   */
  name?: string | null;
  /**
   * Minimum Age
   * @type {number}
   * @memberof IRuleConfigurationVm
   */
  minimumAge?: number | null;
  /**
   * Allowed member types
   * @type {Array<string>}
   * @memberof IRuleConfigurationVm
   */
  allowedMembershipTypes?: Array<string> | null;
  /**
   * Miles from location
   * @type {number}
   * @memberof IRuleConfigurationVm
   */
  milesFromLocation?: number | null;
  /**
   * Required documents
   * @type {Array<string>}
   * @memberof IRuleConfigurationVm
   */
  requiredDocuments?: Array<string> | null;
  /**
   * Conditionally required documents
   * @type {Array<IDocumentWeightedRule>}
   * @memberof IRuleConfigurationVm
   */
  conditionallyRequiredDocuments?: Array<IDocumentWeightedRule> | null;
  /**
   * Time restrictions
   * @type {{ [key: string]: ITimeRestriction; }}
   * @memberof IRuleConfigurationVm
   */
  timeRestrictions?: { [key: string]: ITimeRestriction } | null;
  /**
   * @type {IRateLimited}
   * @memberof IRuleConfigurationVm
   */
  rateLimited?: IRateLimited;
  /**
   * @type {IRuleServicesConfig}
   * @memberof IRuleConfigurationVm
   */
  servicesConfig?: IRuleServicesConfig;
  /**
   * Dynamic rules
   * @type {Array<IRuleDynamicConfig>}
   * @memberof IRuleConfigurationVm
   */
  dynamicRules?: Array<IRuleDynamicConfig> | null;
  /**
   * Required inputs for a document
   * @type {Array<IDocumentTemplateRequirements>}
   * @memberof IRuleConfigurationVm
   */
  templateRequirements?: Array<IDocumentTemplateRequirements> | null;
  /**
   * @type {IRuleConfigRequiredOperator}
   * @memberof IRuleConfigurationVm
   */
  operator?: IRuleConfigRequiredOperator;
}
/**
 * Data types
 * @export
 * @enum {string}
 */

export const IRuleDataType = {
  Boolean: "Boolean",
  DateTime: "DateTime",
  DateTimeOffset: "DateTimeOffset",
  Double: "Double",
  Guid: "Guid",
  Int32: "Int32",
  Int64: "Int64",
  String: "String",
} as const;

export type IRuleDataType = typeof IRuleDataType[keyof typeof IRuleDataType];

/**
 * Dynamic rules
 * @export
 * @interface IRuleDynamicConfig
 */
export interface IRuleDynamicConfig {
  /**
   * Name of the dynamic rules
   * @type {string}
   * @memberof IRuleDynamicConfig
   */
  name?: string;
  /**
   * @type {IRuleDynamicElementType}
   * @memberof IRuleDynamicConfig
   */
  elementType: IRuleDynamicElementType;
  /**
   * List of rules to run
   * @type {Array<IRuleDynamicRules>}
   * @memberof IRuleDynamicConfig
   */
  rules: Array<IRuleDynamicRules>;
}
/**
 *
 * @export
 * @interface IRuleDynamicElementType
 */
export interface IRuleDynamicElementType {
  /**
   * Field
   * @type {string}
   * @memberof IRuleDynamicElementType
   */
  field: string;
  /**
   * Value
   * @type {string}
   * @memberof IRuleDynamicElementType
   */
  value: string;
}
/**
 * Dynamic rules - member of RuleConfiguration
 * @export
 * @interface IRuleDynamicRules
 */
export interface IRuleDynamicRules {
  /**
   * @type {IRuleTriggerType}
   * @memberof IRuleDynamicRules
   */
  trigger: IRuleTriggerType;
  /**
   * Field
   * @type {string}
   * @memberof IRuleDynamicRules
   */
  field: string;
  /**
   * @type {IRuleDataType}
   * @memberof IRuleDynamicRules
   */
  type: IRuleDataType;
  /**
   * @type {IRuleOperatorType}
   * @memberof IRuleDynamicRules
   */
  operator: IRuleOperatorType;
  /**
   * Value
   * @type {any}
   * @memberof IRuleDynamicRules
   */
  value: any;
}
/**
 *
 * @export
 * @interface IRuleEquipmentInfo
 */
export interface IRuleEquipmentInfo {
  /**
   * @type {string}
   * @memberof IRuleEquipmentInfo
   */
  category?: string;
  /**
   * @type {string}
   * @memberof IRuleEquipmentInfo
   */
  subCategory?: string;
  /**
   * @type {string}
   * @memberof IRuleEquipmentInfo
   */
  id?: string | null;
  /**
   * @type {string}
   * @memberof IRuleEquipmentInfo
   */
  partitionKey?: string | null;
  /**
   * @type {string}
   * @memberof IRuleEquipmentInfo
   */
  equipmentId?: string | null;
  /**
   * @type {string}
   * @memberof IRuleEquipmentInfo
   */
  requirementTypeId?: string | null;
  /**
   * @type {{ [key: string]: string; }}
   * @memberof IRuleEquipmentInfo
   */
  requirementTypeIds?: { [key: string]: string } | null;
}
/**
 *
 * @export
 * @interface IRuleEquipmentInfoListIRadianseResult
 */
export interface IRuleEquipmentInfoListIRadianseResult {
  /**
   * @type {number}
   * @memberof IRuleEquipmentInfoListIRadianseResult
   */
  count?: number | null;
  /**
   * @type {Array<IRuleEquipmentInfo>}
   * @memberof IRuleEquipmentInfoListIRadianseResult
   */
  data?: Array<IRuleEquipmentInfo> | null;
  /**
   * @type {string}
   * @memberof IRuleEquipmentInfoListIRadianseResult
   */
  detail: string;
  /**
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IRuleEquipmentInfoListIRadianseResult
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   * @type {string}
   * @memberof IRuleEquipmentInfoListIRadianseResult
   */
  instance?: string | null;
  /**
   * @type {number}
   * @memberof IRuleEquipmentInfoListIRadianseResult
   */
  status?: number;
  /**
   * @type {boolean}
   * @memberof IRuleEquipmentInfoListIRadianseResult
   */
  success?: boolean;
  /**
   * @type {string}
   * @memberof IRuleEquipmentInfoListIRadianseResult
   */
  title?: string;
  /**
   * @type {string}
   * @memberof IRuleEquipmentInfoListIRadianseResult
   */
  traceId?: string | null;
  /**
   * @type {string}
   * @memberof IRuleEquipmentInfoListIRadianseResult
   */
  type?: string | null;
  /**
   * @type {string}
   * @memberof IRuleEquipmentInfoListIRadianseResult
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface IRuleEvaluatorVm
 */
export interface IRuleEvaluatorVm {
  /**
   * Resources to evaluate
   * @type {Array<IScheduleResourceInfo>}
   * @memberof IRuleEvaluatorVm
   */
  resources: Array<IScheduleResourceInfo>;
  /**
   * Start time
   * @type {string}
   * @memberof IRuleEvaluatorVm
   */
  startTime: string;
  /**
   * The distance to the facility.
   * @type {number}
   * @memberof IRuleEvaluatorVm
   */
  distance?: number | null;
  /**
   * @type {IRuleStageType}
   * @memberof IRuleEvaluatorVm
   */
  stage?: IRuleStageType;
  /**
   * Validate rules
   * @type {Array<{ [key: string]: IValidateRulesObj; }>}
   * @memberof IRuleEvaluatorVm
   */
  validateRules?: Array<{ [key: string]: IValidateRulesObj }> | null;
}
/**
 * Group of rules
 * @export
 * @interface IRuleGroup
 */
export interface IRuleGroup {
  /**
   * Id
   * @type {string}
   * @memberof IRuleGroup
   */
  id: string;
  /**
   * Category
   * @type {string}
   * @memberof IRuleGroup
   */
  category?: string | null;
  /**
   * Stored with constant subcategory for operations needed in Radianse.Api.Availability
   * @type {string}
   * @memberof IRuleGroup
   */
  subCategory?: string | null;
  /**
   * PartitionKey = RuleGroup
   * @type {string}
   * @memberof IRuleGroup
   */
  partitionKey: string;
  /**
   * Name
   * @type {string}
   * @memberof IRuleGroup
   */
  name: string;
  /**
   * Rules
   * @type {Array<string>}
   * @memberof IRuleGroup
   */
  rules: Array<string>;
  /**
   * Deleted
   * @type {boolean}
   * @memberof IRuleGroup
   */
  deleted?: boolean | null;
}
/**
 *
 * @export
 * @interface IRuleGroupIRadianseResult
 */
export interface IRuleGroupIRadianseResult {
  /**
   * @type {number}
   * @memberof IRuleGroupIRadianseResult
   */
  count?: number | null;
  /**
   * @type {IRuleGroup}
   * @memberof IRuleGroupIRadianseResult
   */
  data?: IRuleGroup;
  /**
   * @type {string}
   * @memberof IRuleGroupIRadianseResult
   */
  detail: string;
  /**
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IRuleGroupIRadianseResult
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   * @type {string}
   * @memberof IRuleGroupIRadianseResult
   */
  instance?: string | null;
  /**
   * @type {number}
   * @memberof IRuleGroupIRadianseResult
   */
  status?: number;
  /**
   * @type {boolean}
   * @memberof IRuleGroupIRadianseResult
   */
  success?: boolean;
  /**
   * @type {string}
   * @memberof IRuleGroupIRadianseResult
   */
  title?: string;
  /**
   * @type {string}
   * @memberof IRuleGroupIRadianseResult
   */
  traceId?: string | null;
  /**
   * @type {string}
   * @memberof IRuleGroupIRadianseResult
   */
  type?: string | null;
  /**
   * @type {string}
   * @memberof IRuleGroupIRadianseResult
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface IRuleGroupListIRadianseResult
 */
export interface IRuleGroupListIRadianseResult {
  /**
   * @type {number}
   * @memberof IRuleGroupListIRadianseResult
   */
  count?: number | null;
  /**
   * @type {Array<IRuleGroup>}
   * @memberof IRuleGroupListIRadianseResult
   */
  data?: Array<IRuleGroup> | null;
  /**
   * @type {string}
   * @memberof IRuleGroupListIRadianseResult
   */
  detail: string;
  /**
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IRuleGroupListIRadianseResult
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   * @type {string}
   * @memberof IRuleGroupListIRadianseResult
   */
  instance?: string | null;
  /**
   * @type {number}
   * @memberof IRuleGroupListIRadianseResult
   */
  status?: number;
  /**
   * @type {boolean}
   * @memberof IRuleGroupListIRadianseResult
   */
  success?: boolean;
  /**
   * @type {string}
   * @memberof IRuleGroupListIRadianseResult
   */
  title?: string;
  /**
   * @type {string}
   * @memberof IRuleGroupListIRadianseResult
   */
  traceId?: string | null;
  /**
   * @type {string}
   * @memberof IRuleGroupListIRadianseResult
   */
  type?: string | null;
  /**
   * @type {string}
   * @memberof IRuleGroupListIRadianseResult
   */
  continuationToken?: string | null;
}
/**
 * Rule group
 * @export
 * @interface IRuleGroupVm
 */
export interface IRuleGroupVm {
  /**
   * Name
   * @type {string}
   * @memberof IRuleGroupVm
   */
  name: string;
  /**
   * Rules
   * @type {Array<string>}
   * @memberof IRuleGroupVm
   */
  rules: Array<string>;
}
/**
 * Apply the rules a different stages
 * @export
 * @enum {string}
 */

export const IRuleOperatorType = {
  Any: "Any",
  Equals: "Equals",
  Contains: "Contains",
  BeginsWith: "BeginsWith",
  EndsWith: "EndsWith",
  LessThan: "LessThan",
  LessThanOrEquals: "LessThanOrEquals",
  GreaterThan: "GreaterThan",
  GreaterThanOrEquals: "GreaterThanOrEquals",
  NotAny: "NotAny",
  NotEquals: "NotEquals",
  NotContains: "NotContains",
  NotBeginsWith: "NotBeginsWith",
  NotEndsWith: "NotEndsWith",
  NotLessThan: "NotLessThan",
  NotLessThanOrEquals: "NotLessThanOrEquals",
  NotGreaterThan: "NotGreaterThan",
  NotGreaterThanOrEquals: "NotGreaterThanOrEquals",
} as const;

export type IRuleOperatorType =
  typeof IRuleOperatorType[keyof typeof IRuleOperatorType];

/**
 * Rule configuration for the services that are required to schedule equipment
 * @export
 * @interface IRuleServicesConfig
 */
export interface IRuleServicesConfig {
  /**
   * Services applied to a person to give them access to equipment
   * @type {Array<string>}
   * @memberof IRuleServicesConfig
   */
  services: Array<string>;
  /**
   * @type {ILogicalOperatorType}
   * @memberof IRuleServicesConfig
   */
  logicalOperator: ILogicalOperatorType;
}
/**
 * Apply the rules a different stages
 * @export
 * @enum {string}
 */

export const IRuleStageType = {
  Schedule: "Schedule",
  Entry: "Entry",
  Activation: "Activation",
} as const;

export type IRuleStageType = typeof IRuleStageType[keyof typeof IRuleStageType];

/**
 *
 * @export
 * @interface IRuleStageTypeStringDictionaryIRadianseResult
 */
export interface IRuleStageTypeStringDictionaryIRadianseResult {
  /**
   * @type {number}
   * @memberof IRuleStageTypeStringDictionaryIRadianseResult
   */
  count?: number | null;
  /**
   * @type {{ [key: string]: string; }}
   * @memberof IRuleStageTypeStringDictionaryIRadianseResult
   */
  data?: { [key: string]: string } | null;
  /**
   * @type {string}
   * @memberof IRuleStageTypeStringDictionaryIRadianseResult
   */
  detail: string;
  /**
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IRuleStageTypeStringDictionaryIRadianseResult
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   * @type {string}
   * @memberof IRuleStageTypeStringDictionaryIRadianseResult
   */
  instance?: string | null;
  /**
   * @type {number}
   * @memberof IRuleStageTypeStringDictionaryIRadianseResult
   */
  status?: number;
  /**
   * @type {boolean}
   * @memberof IRuleStageTypeStringDictionaryIRadianseResult
   */
  success?: boolean;
  /**
   * @type {string}
   * @memberof IRuleStageTypeStringDictionaryIRadianseResult
   */
  title?: string;
  /**
   * @type {string}
   * @memberof IRuleStageTypeStringDictionaryIRadianseResult
   */
  traceId?: string | null;
  /**
   * @type {string}
   * @memberof IRuleStageTypeStringDictionaryIRadianseResult
   */
  type?: string | null;
  /**
   * @type {string}
   * @memberof IRuleStageTypeStringDictionaryIRadianseResult
   */
  continuationToken?: string | null;
}
/**
 * Rule trigger
 * @export
 * @enum {string}
 */

export const IRuleTriggerType = {
  And: "And",
  Or: "Or",
} as const;

export type IRuleTriggerType =
  typeof IRuleTriggerType[keyof typeof IRuleTriggerType];

/**
 * Class used by RulesValidation. Application Radianse.App.Rules.
 * @export
 * @interface IRulesExecutionDetail
 */
export interface IRulesExecutionDetail {
  /**
   * RuleId
   * @type {string}
   * @memberof IRulesExecutionDetail
   */
  ruleId?: string;
  /**
   * Handler id
   * @type {string}
   * @memberof IRulesExecutionDetail
   */
  handlerId?: string;
  /**
   * Is validated
   * @type {boolean}
   * @memberof IRulesExecutionDetail
   */
  isValidated?: boolean;
  /**
   * Validation reason
   * @type {string}
   * @memberof IRulesExecutionDetail
   */
  validationReason?: string;
  /**
   * Metadata
   * @type {{ [key: string]: IMetaDataInfo; }}
   * @memberof IRulesExecutionDetail
   */
  metaData?: { [key: string]: IMetaDataInfo };
  /**
   * Evaluated at UTC time
   * @type {string}
   * @memberof IRulesExecutionDetail
   */
  evaluatedAt?: string;
  /**
   * Is handled
   * @type {boolean}
   * @memberof IRulesExecutionDetail
   */
  isHandled?: boolean;
}
/**
 *
 * @export
 * @interface IScheduleResourceInfo
 */
export interface IScheduleResourceInfo {
  /**
   * id
   * @type {string}
   * @memberof IScheduleResourceInfo
   */
  id: string;
  /**
   * Partition key
   * @type {string}
   * @memberof IScheduleResourceInfo
   */
  partitionKey: string;
  /**
   * Category
   * @type {string}
   * @memberof IScheduleResourceInfo
   */
  category: string;
  /**
   * SubCategory
   * @type {string}
   * @memberof IScheduleResourceInfo
   */
  subCategory: string;
  /**
   * Name
   * @type {string}
   * @memberof IScheduleResourceInfo
   */
  name: string;
}
/**
 * Search parameters for RequirementValidationResults
 * @export
 * @interface ISearchRequirementValidationResultsReq
 */
export interface ISearchRequirementValidationResultsReq {
  /**
   * @type {IClientTreeType}
   * @memberof ISearchRequirementValidationResultsReq
   */
  clientTreeType?: IClientTreeType;
  /**
   * Query by TimeStamp and apply firstTimeOperator. For example TimeStamp >= 2022-11-01.
   * @type {string}
   * @memberof ISearchRequirementValidationResultsReq
   */
  firstTimeValue?: string | null;
  /**
   * @type {IQueryOperatorType}
   * @memberof ISearchRequirementValidationResultsReq
   */
  firstTimeOperator?: IQueryOperatorType;
  /**
   * Query by TimeStamp and apply SecondTimeOperator. For example TimeStamp <= 2022-12-01.
   * @type {string}
   * @memberof ISearchRequirementValidationResultsReq
   */
  secondTimeValue?: string | null;
  /**
   * @type {IQueryOperatorType}
   * @memberof ISearchRequirementValidationResultsReq
   */
  secondTimeOperator?: IQueryOperatorType;
  /**
   * Search for results that contains one or more of the PendingRules
   * @type {Array<string>}
   * @memberof ISearchRequirementValidationResultsReq
   */
  pendingRules?: Array<string> | null;
  /**
   * Search for results that contains one or more of the RuleFailures
   * @type {Array<string>}
   * @memberof ISearchRequirementValidationResultsReq
   */
  ruleFailures?: Array<string> | null;
  /**
   * null: get all, true: get deleted, false: get active
   * @type {boolean}
   * @memberof ISearchRequirementValidationResultsReq
   */
  deleted?: boolean | null;
}
/**
 *
 * @export
 * @interface IStringIEnumerableIRadianseResult
 */
export interface IStringIEnumerableIRadianseResult {
  /**
   * @type {number}
   * @memberof IStringIEnumerableIRadianseResult
   */
  count?: number | null;
  /**
   * @type {Array<string>}
   * @memberof IStringIEnumerableIRadianseResult
   */
  data?: Array<string> | null;
  /**
   * @type {string}
   * @memberof IStringIEnumerableIRadianseResult
   */
  detail: string;
  /**
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IStringIEnumerableIRadianseResult
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   * @type {string}
   * @memberof IStringIEnumerableIRadianseResult
   */
  instance?: string | null;
  /**
   * @type {number}
   * @memberof IStringIEnumerableIRadianseResult
   */
  status?: number;
  /**
   * @type {boolean}
   * @memberof IStringIEnumerableIRadianseResult
   */
  success?: boolean;
  /**
   * @type {string}
   * @memberof IStringIEnumerableIRadianseResult
   */
  title?: string;
  /**
   * @type {string}
   * @memberof IStringIEnumerableIRadianseResult
   */
  traceId?: string | null;
  /**
   * @type {string}
   * @memberof IStringIEnumerableIRadianseResult
   */
  type?: string | null;
  /**
   * @type {string}
   * @memberof IStringIEnumerableIRadianseResult
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface IStringListIRadianseResult
 */
export interface IStringListIRadianseResult {
  /**
   * @type {number}
   * @memberof IStringListIRadianseResult
   */
  count?: number | null;
  /**
   * @type {Array<string>}
   * @memberof IStringListIRadianseResult
   */
  data?: Array<string> | null;
  /**
   * @type {string}
   * @memberof IStringListIRadianseResult
   */
  detail: string;
  /**
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IStringListIRadianseResult
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   * @type {string}
   * @memberof IStringListIRadianseResult
   */
  instance?: string | null;
  /**
   * @type {number}
   * @memberof IStringListIRadianseResult
   */
  status?: number;
  /**
   * @type {boolean}
   * @memberof IStringListIRadianseResult
   */
  success?: boolean;
  /**
   * @type {string}
   * @memberof IStringListIRadianseResult
   */
  title?: string;
  /**
   * @type {string}
   * @memberof IStringListIRadianseResult
   */
  traceId?: string | null;
  /**
   * @type {string}
   * @memberof IStringListIRadianseResult
   */
  type?: string | null;
  /**
   * @type {string}
   * @memberof IStringListIRadianseResult
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface ITenantConfiguration
 */
export interface ITenantConfiguration {
  /**
   *
   * @type {string}
   * @memberof ITenantConfiguration
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof ITenantConfiguration
   */
  category?: string | null;
  /**
   * Stored with constant subcategory for operations needed in Radianse.Api.Availability
   * @type {string}
   * @memberof ITenantConfiguration
   */
  subCategory?: string | null;
  /**
   * PartitionKey = tenantId
   * @type {string}
   * @memberof ITenantConfiguration
   */
  partitionKey: string;
  /**
   *
   * @type {string}
   * @memberof ITenantConfiguration
   */
  tenantId: string;
  /**
   * Id of the configuration on the RuleConfiguration endpoint
   * @type {string}
   * @memberof ITenantConfiguration
   */
  ruleConfigurationId: string;
  /**
   * Rule requirements. Must pass the rules defined by this requirement type before being allowed to enter the stage
   * @type {string}
   * @memberof ITenantConfiguration
   */
  requirementTypeId?: string | null;
  /**
   * @type {IRuleStageType}
   * @memberof ITenantConfiguration
   */
  stage: IRuleStageType;
  /**
   *
   * @type {boolean}
   * @memberof ITenantConfiguration
   */
  deleted?: boolean | null;
}
/**
 *
 * @export
 * @interface ITenantConfigurationIEnumerableIRadianseResult
 */
export interface ITenantConfigurationIEnumerableIRadianseResult {
  /**
   * @type {number}
   * @memberof ITenantConfigurationIEnumerableIRadianseResult
   */
  count?: number | null;
  /**
   * @type {Array<ITenantConfiguration>}
   * @memberof ITenantConfigurationIEnumerableIRadianseResult
   */
  data?: Array<ITenantConfiguration> | null;
  /**
   * @type {string}
   * @memberof ITenantConfigurationIEnumerableIRadianseResult
   */
  detail: string;
  /**
   * @type {{ [key: string]: Array<string>; }}
   * @memberof ITenantConfigurationIEnumerableIRadianseResult
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   * @type {string}
   * @memberof ITenantConfigurationIEnumerableIRadianseResult
   */
  instance?: string | null;
  /**
   * @type {number}
   * @memberof ITenantConfigurationIEnumerableIRadianseResult
   */
  status?: number;
  /**
   * @type {boolean}
   * @memberof ITenantConfigurationIEnumerableIRadianseResult
   */
  success?: boolean;
  /**
   * @type {string}
   * @memberof ITenantConfigurationIEnumerableIRadianseResult
   */
  title?: string;
  /**
   * @type {string}
   * @memberof ITenantConfigurationIEnumerableIRadianseResult
   */
  traceId?: string | null;
  /**
   * @type {string}
   * @memberof ITenantConfigurationIEnumerableIRadianseResult
   */
  type?: string | null;
  /**
   * @type {string}
   * @memberof ITenantConfigurationIEnumerableIRadianseResult
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface ITenantConfigurationIRadianseResult
 */
export interface ITenantConfigurationIRadianseResult {
  /**
   * @type {number}
   * @memberof ITenantConfigurationIRadianseResult
   */
  count?: number | null;
  /**
   * @type {ITenantConfiguration}
   * @memberof ITenantConfigurationIRadianseResult
   */
  data?: ITenantConfiguration;
  /**
   * @type {string}
   * @memberof ITenantConfigurationIRadianseResult
   */
  detail: string;
  /**
   * @type {{ [key: string]: Array<string>; }}
   * @memberof ITenantConfigurationIRadianseResult
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   * @type {string}
   * @memberof ITenantConfigurationIRadianseResult
   */
  instance?: string | null;
  /**
   * @type {number}
   * @memberof ITenantConfigurationIRadianseResult
   */
  status?: number;
  /**
   * @type {boolean}
   * @memberof ITenantConfigurationIRadianseResult
   */
  success?: boolean;
  /**
   * @type {string}
   * @memberof ITenantConfigurationIRadianseResult
   */
  title?: string;
  /**
   * @type {string}
   * @memberof ITenantConfigurationIRadianseResult
   */
  traceId?: string | null;
  /**
   * @type {string}
   * @memberof ITenantConfigurationIRadianseResult
   */
  type?: string | null;
  /**
   * @type {string}
   * @memberof ITenantConfigurationIRadianseResult
   */
  continuationToken?: string | null;
}
/**
 * Class used by RuleConfiguration. Application Radianse.App.Rules
 * @export
 * @interface ITimeRestriction
 */
export interface ITimeRestriction {
  /**
   * IDs of the restricted element type
   * @type {Array<string>}
   * @memberof ITimeRestriction
   */
  restrictedTypes: Array<string>;
  /**
   * Time of restriction
   * @type {number}
   * @memberof ITimeRestriction
   */
  restrictionTimeInMinutes: number;
  /**
   * Maximum allowed times
   * @type {number}
   * @memberof ITimeRestriction
   */
  maximumOccurancesPerTimespan: number;
  /**
   * @type {ITimeRestrictionElementType}
   * @memberof ITimeRestriction
   */
  elementType: ITimeRestrictionElementType;
}
/**
 *
 * @export
 * @enum {string}
 */

export const ITimeRestrictionElementType = {
  ElementTree: "ElementTree",
  Events: "Events",
} as const;

export type ITimeRestrictionElementType =
  typeof ITimeRestrictionElementType[keyof typeof ITimeRestrictionElementType];

/**
 * The object to pass into /RuleEvaluator validateRules parameter
 * @export
 * @interface IValidateRulesObj
 */
export interface IValidateRulesObj {
  /**
   * The id of the Operator
   * @type {string}
   * @memberof IValidateRulesObj
   */
  operatorId?: string | null;
  /**
   * The partitionKey of the Operator
   * @type {string}
   * @memberof IValidateRulesObj
   */
  operatorPartitionKey?: string;
}
/**
 * Validation model
 * @export
 * @interface IValidationModel
 */
export interface IValidationModel {
  /**
   * Requirement type id
   * @type {string}
   * @memberof IValidationModel
   */
  requirementTypeId: string;
  /**
   * Rules token
   * @type {string}
   * @memberof IValidationModel
   */
  rulesToken: string;
}
/**
 * Validation response
 * @export
 * @interface IValidationResponse
 */
export interface IValidationResponse {
  /**
   * id
   * @type {string}
   * @memberof IValidationResponse
   */
  id: string;
  /**
   * True if all rules passed
   * @type {boolean}
   * @memberof IValidationResponse
   */
  isValid?: boolean;
  /**
   * Reason for pass or failure
   * @type {string}
   * @memberof IValidationResponse
   */
  reason: string;
}
/**
 *
 * @export
 * @interface IValidationResponseIRadianseResult
 */
export interface IValidationResponseIRadianseResult {
  /**
   * @type {number}
   * @memberof IValidationResponseIRadianseResult
   */
  count?: number | null;
  /**
   * @type {IValidationResponse}
   * @memberof IValidationResponseIRadianseResult
   */
  data?: IValidationResponse;
  /**
   * @type {string}
   * @memberof IValidationResponseIRadianseResult
   */
  detail: string;
  /**
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IValidationResponseIRadianseResult
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   * @type {string}
   * @memberof IValidationResponseIRadianseResult
   */
  instance?: string | null;
  /**
   * @type {number}
   * @memberof IValidationResponseIRadianseResult
   */
  status?: number;
  /**
   * @type {boolean}
   * @memberof IValidationResponseIRadianseResult
   */
  success?: boolean;
  /**
   * @type {string}
   * @memberof IValidationResponseIRadianseResult
   */
  title?: string;
  /**
   * @type {string}
   * @memberof IValidationResponseIRadianseResult
   */
  traceId?: string | null;
  /**
   * @type {string}
   * @memberof IValidationResponseIRadianseResult
   */
  type?: string | null;
  /**
   * @type {string}
   * @memberof IValidationResponseIRadianseResult
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface IValidationResponseListIRadianseResult
 */
export interface IValidationResponseListIRadianseResult {
  /**
   * @type {number}
   * @memberof IValidationResponseListIRadianseResult
   */
  count?: number | null;
  /**
   * @type {Array<IValidationResponse>}
   * @memberof IValidationResponseListIRadianseResult
   */
  data?: Array<IValidationResponse> | null;
  /**
   * @type {string}
   * @memberof IValidationResponseListIRadianseResult
   */
  detail: string;
  /**
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IValidationResponseListIRadianseResult
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   * @type {string}
   * @memberof IValidationResponseListIRadianseResult
   */
  instance?: string | null;
  /**
   * @type {number}
   * @memberof IValidationResponseListIRadianseResult
   */
  status?: number;
  /**
   * @type {boolean}
   * @memberof IValidationResponseListIRadianseResult
   */
  success?: boolean;
  /**
   * @type {string}
   * @memberof IValidationResponseListIRadianseResult
   */
  title?: string;
  /**
   * @type {string}
   * @memberof IValidationResponseListIRadianseResult
   */
  traceId?: string | null;
  /**
   * @type {string}
   * @memberof IValidationResponseListIRadianseResult
   */
  type?: string | null;
  /**
   * @type {string}
   * @memberof IValidationResponseListIRadianseResult
   */
  continuationToken?: string | null;
}

/**
 * CustomerConfigurationsApi - axios parameter creator
 * @export
 */
export const CustomerConfigurationsApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Permission: customerconfiguration_delete
     * @summary Delete customer configuration
     * @param {IRuleStageType} [requestParameters.stage]
     * @param {string} [requestParameters.apiVersion] The requested API version
     * @param {string} [requestParameters.acceptLanguage]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    userApiCustomerConfigurationsDelete: async (
      stage?: IRuleStageType,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/CustomerConfigurations`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (stage !== undefined) {
        localVarQueryParameter["stage"] = stage;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: customerconfiguration_read
     * @summary Get customer configuration. Rules applied customer wide.
     * @param {IRuleStageType} [requestParameters.stage]
     * @param {string} [requestParameters.apiVersion] The requested API version
     * @param {string} [requestParameters.acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiCustomerConfigurationsGet: async (
      stage?: IRuleStageType,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/CustomerConfigurations`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (stage !== undefined) {
        localVarQueryParameter["stage"] = stage;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: customerconfiguration_create  <br>Id in storage is the customerId
     * @summary Create or update customer configuration
     * @param {string} [requestParameters.apiVersion] The requested API version
     * @param {string} [requestParameters.acceptLanguage]
     * @param {IElementConfigurationVm} [requestParameters.iElementConfigurationVm]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    userApiCustomerConfigurationsPut: async (
      apiVersion?: string,
      acceptLanguage?: string,
      iElementConfigurationVm?: IElementConfigurationVm,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/CustomerConfigurations`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        iElementConfigurationVm,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * CustomerConfigurationsApi - functional programming interface
 * @export
 */
export const CustomerConfigurationsApiFp = function (
  configuration?: Configuration
) {
  const localVarAxiosParamCreator =
    CustomerConfigurationsApiAxiosParamCreator(configuration);
  return {
    /**
     * Permission: customerconfiguration_delete
     * Fp
     * @summary Delete customer configuration
     * @param {IRuleStageType} [stage]
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async userApiCustomerConfigurationsDelete(
      stage?: IRuleStageType,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<ICustomerConfigurationIRadianseResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiCustomerConfigurationsDelete(
          stage,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },

    /**
     * Permission: customerconfiguration_read
     * Fp
     * @summary Get customer configuration. Rules applied customer wide.
     * @param {IRuleStageType} [stage]
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiCustomerConfigurationsGet(
      stage?: IRuleStageType,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<ICustomerConfigurationIRadianseResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiCustomerConfigurationsGet(
          stage,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },

    /**
     * Permission: customerconfiguration_create  <br>Id in storage is the customerId
     * Fp
     * @summary Create or update customer configuration
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IElementConfigurationVm} [iElementConfigurationVm]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async userApiCustomerConfigurationsPut(
      apiVersion?: string,
      acceptLanguage?: string,
      iElementConfigurationVm?: IElementConfigurationVm,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<ICustomerConfigurationIRadianseResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiCustomerConfigurationsPut(
          apiVersion,
          acceptLanguage,
          iElementConfigurationVm,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * CustomerConfigurationsApi - factory interface
 * @export
 */
export const CustomerConfigurationsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = CustomerConfigurationsApiFp(configuration);
  return {
    /**
     * Permission: customerconfiguration_delete
     * Factory
     * @summary Delete customer configuration
     * @param {IRuleStageType} [stage]
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    userApiCustomerConfigurationsDelete(
      stage?: IRuleStageType,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<ICustomerConfigurationIRadianseResult> {
      return localVarFp
        .userApiCustomerConfigurationsDelete(
          stage,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: customerconfiguration_read
     * Factory
     * @summary Get customer configuration. Rules applied customer wide.
     * @param {IRuleStageType} [stage]
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiCustomerConfigurationsGet(
      stage?: IRuleStageType,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<ICustomerConfigurationIRadianseResult> {
      return localVarFp
        .userApiCustomerConfigurationsGet(
          stage,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: customerconfiguration_create  <br>Id in storage is the customerId
     * Factory
     * @summary Create or update customer configuration
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IElementConfigurationVm} [iElementConfigurationVm]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    userApiCustomerConfigurationsPut(
      apiVersion?: string,
      acceptLanguage?: string,
      iElementConfigurationVm?: IElementConfigurationVm,
      options?: any
    ): AxiosPromise<ICustomerConfigurationIRadianseResult> {
      return localVarFp
        .userApiCustomerConfigurationsPut(
          apiVersion,
          acceptLanguage,
          iElementConfigurationVm,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * CustomerConfigurationsApi - object-oriented interface
 * @export
 * @class CustomerConfigurationsApi
 * @extends {BaseAPI}
 */
export class CustomerConfigurationsApi extends BaseAPI {
  /**
   * Permission: customerconfiguration_delete
   * --TEST
   * @summary Delete customer configuration
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof CustomerConfigurationsApi
   */
  public userApiCustomerConfigurationsDelete(
    stage?: IRuleStageType,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return CustomerConfigurationsApiFp(this.configuration)
      .userApiCustomerConfigurationsDelete(
        stage,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: customerconfiguration_read
   * --TEST
   * @summary Get customer configuration. Rules applied customer wide.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CustomerConfigurationsApi
   */
  public userApiCustomerConfigurationsGet(
    stage?: IRuleStageType,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return CustomerConfigurationsApiFp(this.configuration)
      .userApiCustomerConfigurationsGet(
        stage,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: customerconfiguration_create  <br>Id in storage is the customerId
   * --TEST
   * @summary Create or update customer configuration
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof CustomerConfigurationsApi
   */
  public userApiCustomerConfigurationsPut(
    apiVersion?: string,
    acceptLanguage?: string,
    iElementConfigurationVm?: IElementConfigurationVm,
    options?: AxiosRequestConfig
  ) {
    return CustomerConfigurationsApiFp(this.configuration)
      .userApiCustomerConfigurationsPut(
        apiVersion,
        acceptLanguage,
        iElementConfigurationVm,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * EquipmentConfigurationsApi - axios parameter creator
 * @export
 */
export const EquipmentConfigurationsApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Permission: equipmentconfigurations_delete
     * @summary Delete equipment configuration
     * @param {string} requestParameters.equipmentId
     * @param {IRuleStageType} [requestParameters.stage]
     * @param {string} [requestParameters.tenantId] TenantId is required if using a bearer token.
     * @param {string} [requestParameters.apiVersion] The requested API version
     * @param {string} [requestParameters.acceptLanguage]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    userApiEquipmentConfigurationsEquipmentIdDelete: async (
      equipmentId: string,
      stage?: IRuleStageType,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'equipmentId' is not null or undefined
      assertParamExists(
        "userApiEquipmentConfigurationsEquipmentIdDelete",
        "equipmentId",
        equipmentId
      );
      const localVarPath =
        `/UserApi/EquipmentConfigurations/{equipmentId}`.replace(
          `{${"equipmentId"}}`,
          encodeURIComponent(String(equipmentId))
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (stage !== undefined) {
        localVarQueryParameter["stage"] = stage;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: equipmentconfigurations_read
     * @summary Get equipment configurations by Equipment ID
     * @param {string} requestParameters.equipmentId
     * @param {IRuleStageType} [requestParameters.stage]
     * @param {string} [requestParameters.tenantId] TenantId is required if using a bearer token.
     * @param {string} [requestParameters.apiVersion] The requested API version
     * @param {string} [requestParameters.acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiEquipmentConfigurationsEquipmentIdGet: async (
      equipmentId: string,
      stage?: IRuleStageType,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'equipmentId' is not null or undefined
      assertParamExists(
        "userApiEquipmentConfigurationsEquipmentIdGet",
        "equipmentId",
        equipmentId
      );
      const localVarPath =
        `/UserApi/EquipmentConfigurations/{equipmentId}`.replace(
          `{${"equipmentId"}}`,
          encodeURIComponent(String(equipmentId))
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (stage !== undefined) {
        localVarQueryParameter["stage"] = stage;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: equipmentconfigurations_create              <br>Id must match the equipment id from radianse.app.elements application
     * @summary Create or update equipment configuration
     * @param {string} requestParameters.equipmentId
     * @param {string} [requestParameters.tenantId] TenantId is required if using a bearer token.
     * @param {string} [requestParameters.apiVersion] The requested API version
     * @param {string} [requestParameters.acceptLanguage]
     * @param {IElementConfigurationVm} [requestParameters.iElementConfigurationVm]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    userApiEquipmentConfigurationsEquipmentIdPut: async (
      equipmentId: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iElementConfigurationVm?: IElementConfigurationVm,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'equipmentId' is not null or undefined
      assertParamExists(
        "userApiEquipmentConfigurationsEquipmentIdPut",
        "equipmentId",
        equipmentId
      );
      const localVarPath =
        `/UserApi/EquipmentConfigurations/{equipmentId}`.replace(
          `{${"equipmentId"}}`,
          encodeURIComponent(String(equipmentId))
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        iElementConfigurationVm,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: equipmentconfigurations_read
     * @summary Get equipment configurations
     * @param {IClientTreeType} [requestParameters.clientTreeType] Customer: Get all on customer. Group: Get all for group. Tenant: Get all for tenant
     * @param {boolean} [requestParameters.deleted]
     * @param {string} [requestParameters.groupId]
     * @param {string} [requestParameters.tenantId]
     * @param {string} [requestParameters.apiVersion] The requested API version
     * @param {string} [requestParameters.acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiEquipmentConfigurationsGet: async (
      clientTreeType?: IClientTreeType,
      deleted?: boolean,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/EquipmentConfigurations`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (clientTreeType !== undefined) {
        localVarQueryParameter["clientTreeType"] = clientTreeType;
      }

      if (deleted !== undefined) {
        localVarQueryParameter["deleted"] = deleted;
      }

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * EquipmentConfigurationsApi - functional programming interface
 * @export
 */
export const EquipmentConfigurationsApiFp = function (
  configuration?: Configuration
) {
  const localVarAxiosParamCreator =
    EquipmentConfigurationsApiAxiosParamCreator(configuration);
  return {
    /**
     * Permission: equipmentconfigurations_delete
     * Fp
     * @summary Delete equipment configuration
     * @param {string} equipmentId
     * @param {IRuleStageType} [stage]
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async userApiEquipmentConfigurationsEquipmentIdDelete(
      equipmentId: string,
      stage?: IRuleStageType,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IEquipmentConfigurationIRadianseResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiEquipmentConfigurationsEquipmentIdDelete(
          equipmentId,
          stage,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },

    /**
     * Permission: equipmentconfigurations_read
     * Fp
     * @summary Get equipment configurations by Equipment ID
     * @param {string} equipmentId
     * @param {IRuleStageType} [stage]
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiEquipmentConfigurationsEquipmentIdGet(
      equipmentId: string,
      stage?: IRuleStageType,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IEquipmentConfigurationIRadianseResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiEquipmentConfigurationsEquipmentIdGet(
          equipmentId,
          stage,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },

    /**
     * Permission: equipmentconfigurations_create              <br>Id must match the equipment id from radianse.app.elements application
     * Fp
     * @summary Create or update equipment configuration
     * @param {string} equipmentId
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IElementConfigurationVm} [iElementConfigurationVm]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async userApiEquipmentConfigurationsEquipmentIdPut(
      equipmentId: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iElementConfigurationVm?: IElementConfigurationVm,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IEquipmentConfigurationIRadianseResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiEquipmentConfigurationsEquipmentIdPut(
          equipmentId,
          tenantId,
          apiVersion,
          acceptLanguage,
          iElementConfigurationVm,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },

    /**
     * Permission: equipmentconfigurations_read
     * Fp
     * @summary Get equipment configurations
     * @param {IClientTreeType} [clientTreeType] Customer: Get all on customer. Group: Get all for group. Tenant: Get all for tenant
     * @param {boolean} [deleted]
     * @param {string} [groupId]
     * @param {string} [tenantId]
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiEquipmentConfigurationsGet(
      clientTreeType?: IClientTreeType,
      deleted?: boolean,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IEquipmentConfigurationListIRadianseResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiEquipmentConfigurationsGet(
          clientTreeType,
          deleted,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * EquipmentConfigurationsApi - factory interface
 * @export
 */
export const EquipmentConfigurationsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = EquipmentConfigurationsApiFp(configuration);
  return {
    /**
     * Permission: equipmentconfigurations_delete
     * Factory
     * @summary Delete equipment configuration
     * @param {string} equipmentId
     * @param {IRuleStageType} [stage]
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    userApiEquipmentConfigurationsEquipmentIdDelete(
      equipmentId: string,
      stage?: IRuleStageType,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IEquipmentConfigurationIRadianseResult> {
      return localVarFp
        .userApiEquipmentConfigurationsEquipmentIdDelete(
          equipmentId,
          stage,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: equipmentconfigurations_read
     * Factory
     * @summary Get equipment configurations by Equipment ID
     * @param {string} equipmentId
     * @param {IRuleStageType} [stage]
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiEquipmentConfigurationsEquipmentIdGet(
      equipmentId: string,
      stage?: IRuleStageType,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IEquipmentConfigurationIRadianseResult> {
      return localVarFp
        .userApiEquipmentConfigurationsEquipmentIdGet(
          equipmentId,
          stage,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: equipmentconfigurations_create              <br>Id must match the equipment id from radianse.app.elements application
     * Factory
     * @summary Create or update equipment configuration
     * @param {string} equipmentId
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IElementConfigurationVm} [iElementConfigurationVm]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    userApiEquipmentConfigurationsEquipmentIdPut(
      equipmentId: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iElementConfigurationVm?: IElementConfigurationVm,
      options?: any
    ): AxiosPromise<IEquipmentConfigurationIRadianseResult> {
      return localVarFp
        .userApiEquipmentConfigurationsEquipmentIdPut(
          equipmentId,
          tenantId,
          apiVersion,
          acceptLanguage,
          iElementConfigurationVm,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: equipmentconfigurations_read
     * Factory
     * @summary Get equipment configurations
     * @param {IClientTreeType} [clientTreeType] Customer: Get all on customer. Group: Get all for group. Tenant: Get all for tenant
     * @param {boolean} [deleted]
     * @param {string} [groupId]
     * @param {string} [tenantId]
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiEquipmentConfigurationsGet(
      clientTreeType?: IClientTreeType,
      deleted?: boolean,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IEquipmentConfigurationListIRadianseResult> {
      return localVarFp
        .userApiEquipmentConfigurationsGet(
          clientTreeType,
          deleted,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * EquipmentConfigurationsApi - object-oriented interface
 * @export
 * @class EquipmentConfigurationsApi
 * @extends {BaseAPI}
 */
export class EquipmentConfigurationsApi extends BaseAPI {
  /**
   * Permission: equipmentconfigurations_delete
   * --TEST
   * @summary Delete equipment configuration
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof EquipmentConfigurationsApi
   */
  public userApiEquipmentConfigurationsEquipmentIdDelete(
    equipmentId: string,
    stage?: IRuleStageType,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return EquipmentConfigurationsApiFp(this.configuration)
      .userApiEquipmentConfigurationsEquipmentIdDelete(
        equipmentId,
        stage,
        tenantId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: equipmentconfigurations_read
   * --TEST
   * @summary Get equipment configurations by Equipment ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EquipmentConfigurationsApi
   */
  public userApiEquipmentConfigurationsEquipmentIdGet(
    equipmentId: string,
    stage?: IRuleStageType,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return EquipmentConfigurationsApiFp(this.configuration)
      .userApiEquipmentConfigurationsEquipmentIdGet(
        equipmentId,
        stage,
        tenantId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: equipmentconfigurations_create              <br>Id must match the equipment id from radianse.app.elements application
   * --TEST
   * @summary Create or update equipment configuration
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof EquipmentConfigurationsApi
   */
  public userApiEquipmentConfigurationsEquipmentIdPut(
    equipmentId: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    iElementConfigurationVm?: IElementConfigurationVm,
    options?: AxiosRequestConfig
  ) {
    return EquipmentConfigurationsApiFp(this.configuration)
      .userApiEquipmentConfigurationsEquipmentIdPut(
        equipmentId,
        tenantId,
        apiVersion,
        acceptLanguage,
        iElementConfigurationVm,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: equipmentconfigurations_read
   * --TEST
   * @summary Get equipment configurations
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EquipmentConfigurationsApi
   */
  public userApiEquipmentConfigurationsGet(
    clientTreeType?: IClientTreeType,
    deleted?: boolean,
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return EquipmentConfigurationsApiFp(this.configuration)
      .userApiEquipmentConfigurationsGet(
        clientTreeType,
        deleted,
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * EventsConfigurationsApi - axios parameter creator
 * @export
 */
export const EventsConfigurationsApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Permission: eventsconfigurations_delete
     * @summary Delete an events
     * @param {string} requestParameters.eventsId
     * @param {IRuleStageType} [requestParameters.stage]
     * @param {string} [requestParameters.tenantId] TenantId is required if using a bearer token.
     * @param {string} [requestParameters.apiVersion] The requested API version
     * @param {string} [requestParameters.acceptLanguage]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    userApiEventsConfigurationsEventsIdDelete: async (
      eventsId: string,
      stage?: IRuleStageType,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'eventsId' is not null or undefined
      assertParamExists(
        "userApiEventsConfigurationsEventsIdDelete",
        "eventsId",
        eventsId
      );
      const localVarPath = `/UserApi/EventsConfigurations/{eventsId}`.replace(
        `{${"eventsId"}}`,
        encodeURIComponent(String(eventsId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (stage !== undefined) {
        localVarQueryParameter["stage"] = stage;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: eventsconfigurations_read
     * @summary Get events configurations by eventsId
     * @param {string} requestParameters.eventsId The rule configuration to apply to an events.Id
     * @param {IRuleStageType} [requestParameters.stage]
     * @param {string} [requestParameters.tenantId] TenantId is required if using a bearer token.
     * @param {string} [requestParameters.apiVersion] The requested API version
     * @param {string} [requestParameters.acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiEventsConfigurationsEventsIdGet: async (
      eventsId: string,
      stage?: IRuleStageType,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'eventsId' is not null or undefined
      assertParamExists(
        "userApiEventsConfigurationsEventsIdGet",
        "eventsId",
        eventsId
      );
      const localVarPath = `/UserApi/EventsConfigurations/{eventsId}`.replace(
        `{${"eventsId"}}`,
        encodeURIComponent(String(eventsId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (stage !== undefined) {
        localVarQueryParameter["stage"] = stage;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: eventsconfigurations_create              <br>Id must match the events id from radianse.app.elements application
     * @summary Create or update an existing events configuration
     * @param {string} requestParameters.eventsId
     * @param {string} [requestParameters.tenantId] TenantId is required if using a bearer token.
     * @param {string} [requestParameters.apiVersion] The requested API version
     * @param {string} [requestParameters.acceptLanguage]
     * @param {IElementConfigurationVm} [requestParameters.iElementConfigurationVm]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    userApiEventsConfigurationsEventsIdPut: async (
      eventsId: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iElementConfigurationVm?: IElementConfigurationVm,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'eventsId' is not null or undefined
      assertParamExists(
        "userApiEventsConfigurationsEventsIdPut",
        "eventsId",
        eventsId
      );
      const localVarPath = `/UserApi/EventsConfigurations/{eventsId}`.replace(
        `{${"eventsId"}}`,
        encodeURIComponent(String(eventsId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        iElementConfigurationVm,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: eventsconfigurations_read
     * @summary Get events configurations
     * @param {IClientTreeType} [requestParameters.clientTreeType] Customer: Get all on customer. Group: Get all for group. Tenant: Get all for tenant
     * @param {boolean} [requestParameters.deleted]
     * @param {string} [requestParameters.groupId]
     * @param {string} [requestParameters.tenantId]
     * @param {string} [requestParameters.apiVersion] The requested API version
     * @param {string} [requestParameters.acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiEventsConfigurationsGet: async (
      clientTreeType?: IClientTreeType,
      deleted?: boolean,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/EventsConfigurations`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (clientTreeType !== undefined) {
        localVarQueryParameter["clientTreeType"] = clientTreeType;
      }

      if (deleted !== undefined) {
        localVarQueryParameter["deleted"] = deleted;
      }

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * EventsConfigurationsApi - functional programming interface
 * @export
 */
export const EventsConfigurationsApiFp = function (
  configuration?: Configuration
) {
  const localVarAxiosParamCreator =
    EventsConfigurationsApiAxiosParamCreator(configuration);
  return {
    /**
     * Permission: eventsconfigurations_delete
     * Fp
     * @summary Delete an events
     * @param {string} eventsId
     * @param {IRuleStageType} [stage]
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async userApiEventsConfigurationsEventsIdDelete(
      eventsId: string,
      stage?: IRuleStageType,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IEventsConfigurationIRadianseResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiEventsConfigurationsEventsIdDelete(
          eventsId,
          stage,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },

    /**
     * Permission: eventsconfigurations_read
     * Fp
     * @summary Get events configurations by eventsId
     * @param {string} eventsId The rule configuration to apply to an events.Id
     * @param {IRuleStageType} [stage]
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiEventsConfigurationsEventsIdGet(
      eventsId: string,
      stage?: IRuleStageType,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IEventsConfigurationIRadianseResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiEventsConfigurationsEventsIdGet(
          eventsId,
          stage,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },

    /**
     * Permission: eventsconfigurations_create              <br>Id must match the events id from radianse.app.elements application
     * Fp
     * @summary Create or update an existing events configuration
     * @param {string} eventsId
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IElementConfigurationVm} [iElementConfigurationVm]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async userApiEventsConfigurationsEventsIdPut(
      eventsId: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iElementConfigurationVm?: IElementConfigurationVm,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IEventsConfigurationIRadianseResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiEventsConfigurationsEventsIdPut(
          eventsId,
          tenantId,
          apiVersion,
          acceptLanguage,
          iElementConfigurationVm,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },

    /**
     * Permission: eventsconfigurations_read
     * Fp
     * @summary Get events configurations
     * @param {IClientTreeType} [clientTreeType] Customer: Get all on customer. Group: Get all for group. Tenant: Get all for tenant
     * @param {boolean} [deleted]
     * @param {string} [groupId]
     * @param {string} [tenantId]
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiEventsConfigurationsGet(
      clientTreeType?: IClientTreeType,
      deleted?: boolean,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IEventsConfigurationListRadianseResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiEventsConfigurationsGet(
          clientTreeType,
          deleted,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * EventsConfigurationsApi - factory interface
 * @export
 */
export const EventsConfigurationsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = EventsConfigurationsApiFp(configuration);
  return {
    /**
     * Permission: eventsconfigurations_delete
     * Factory
     * @summary Delete an events
     * @param {string} eventsId
     * @param {IRuleStageType} [stage]
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    userApiEventsConfigurationsEventsIdDelete(
      eventsId: string,
      stage?: IRuleStageType,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IEventsConfigurationIRadianseResult> {
      return localVarFp
        .userApiEventsConfigurationsEventsIdDelete(
          eventsId,
          stage,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: eventsconfigurations_read
     * Factory
     * @summary Get events configurations by eventsId
     * @param {string} eventsId The rule configuration to apply to an events.Id
     * @param {IRuleStageType} [stage]
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiEventsConfigurationsEventsIdGet(
      eventsId: string,
      stage?: IRuleStageType,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IEventsConfigurationIRadianseResult> {
      return localVarFp
        .userApiEventsConfigurationsEventsIdGet(
          eventsId,
          stage,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: eventsconfigurations_create              <br>Id must match the events id from radianse.app.elements application
     * Factory
     * @summary Create or update an existing events configuration
     * @param {string} eventsId
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IElementConfigurationVm} [iElementConfigurationVm]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    userApiEventsConfigurationsEventsIdPut(
      eventsId: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iElementConfigurationVm?: IElementConfigurationVm,
      options?: any
    ): AxiosPromise<IEventsConfigurationIRadianseResult> {
      return localVarFp
        .userApiEventsConfigurationsEventsIdPut(
          eventsId,
          tenantId,
          apiVersion,
          acceptLanguage,
          iElementConfigurationVm,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: eventsconfigurations_read
     * Factory
     * @summary Get events configurations
     * @param {IClientTreeType} [clientTreeType] Customer: Get all on customer. Group: Get all for group. Tenant: Get all for tenant
     * @param {boolean} [deleted]
     * @param {string} [groupId]
     * @param {string} [tenantId]
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiEventsConfigurationsGet(
      clientTreeType?: IClientTreeType,
      deleted?: boolean,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IEventsConfigurationListRadianseResult> {
      return localVarFp
        .userApiEventsConfigurationsGet(
          clientTreeType,
          deleted,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * EventsConfigurationsApi - object-oriented interface
 * @export
 * @class EventsConfigurationsApi
 * @extends {BaseAPI}
 */
export class EventsConfigurationsApi extends BaseAPI {
  /**
   * Permission: eventsconfigurations_delete
   * --TEST
   * @summary Delete an events
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof EventsConfigurationsApi
   */
  public userApiEventsConfigurationsEventsIdDelete(
    eventsId: string,
    stage?: IRuleStageType,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return EventsConfigurationsApiFp(this.configuration)
      .userApiEventsConfigurationsEventsIdDelete(
        eventsId,
        stage,
        tenantId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: eventsconfigurations_read
   * --TEST
   * @summary Get events configurations by eventsId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EventsConfigurationsApi
   */
  public userApiEventsConfigurationsEventsIdGet(
    eventsId: string,
    stage?: IRuleStageType,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return EventsConfigurationsApiFp(this.configuration)
      .userApiEventsConfigurationsEventsIdGet(
        eventsId,
        stage,
        tenantId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: eventsconfigurations_create              <br>Id must match the events id from radianse.app.elements application
   * --TEST
   * @summary Create or update an existing events configuration
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof EventsConfigurationsApi
   */
  public userApiEventsConfigurationsEventsIdPut(
    eventsId: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    iElementConfigurationVm?: IElementConfigurationVm,
    options?: AxiosRequestConfig
  ) {
    return EventsConfigurationsApiFp(this.configuration)
      .userApiEventsConfigurationsEventsIdPut(
        eventsId,
        tenantId,
        apiVersion,
        acceptLanguage,
        iElementConfigurationVm,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: eventsconfigurations_read
   * --TEST
   * @summary Get events configurations
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EventsConfigurationsApi
   */
  public userApiEventsConfigurationsGet(
    clientTreeType?: IClientTreeType,
    deleted?: boolean,
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return EventsConfigurationsApiFp(this.configuration)
      .userApiEventsConfigurationsGet(
        clientTreeType,
        deleted,
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * MetadataApi - axios parameter creator
 * @export
 */
export const MetadataApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Permission: metadata_read
     * @summary Returns a list of rule types that can be handled by the rule manager
     * @param {string} requestParameters.ruleManagerId
     * @param {string} [requestParameters.apiVersion] The requested API version
     * @param {string} [requestParameters.acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiMetadataGetHandledRulesRuleManagerIdGet: async (
      ruleManagerId: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'ruleManagerId' is not null or undefined
      assertParamExists(
        "userApiMetadataGetHandledRulesRuleManagerIdGet",
        "ruleManagerId",
        ruleManagerId
      );
      const localVarPath =
        `/UserApi/Metadata/GetHandledRules/{ruleManagerId}`.replace(
          `{${"ruleManagerId"}}`,
          encodeURIComponent(String(ruleManagerId))
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: metadata_read
     * @summary Returns a list of rule managers that are available to the application
     * @param {string} [requestParameters.apiVersion] The requested API version
     * @param {string} [requestParameters.acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiMetadataGetRuleManagersGet: async (
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/Metadata/GetRuleManagers`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * MetadataApi - functional programming interface
 * @export
 */
export const MetadataApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = MetadataApiAxiosParamCreator(configuration);
  return {
    /**
     * Permission: metadata_read
     * Fp
     * @summary Returns a list of rule types that can be handled by the rule manager
     * @param {string} ruleManagerId
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiMetadataGetHandledRulesRuleManagerIdGet(
      ruleManagerId: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IStringIEnumerableIRadianseResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiMetadataGetHandledRulesRuleManagerIdGet(
          ruleManagerId,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },

    /**
     * Permission: metadata_read
     * Fp
     * @summary Returns a list of rule managers that are available to the application
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiMetadataGetRuleManagersGet(
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IStringIEnumerableIRadianseResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiMetadataGetRuleManagersGet(
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * MetadataApi - factory interface
 * @export
 */
export const MetadataApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = MetadataApiFp(configuration);
  return {
    /**
     * Permission: metadata_read
     * Factory
     * @summary Returns a list of rule types that can be handled by the rule manager
     * @param {string} ruleManagerId
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiMetadataGetHandledRulesRuleManagerIdGet(
      ruleManagerId: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IStringIEnumerableIRadianseResult> {
      return localVarFp
        .userApiMetadataGetHandledRulesRuleManagerIdGet(
          ruleManagerId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: metadata_read
     * Factory
     * @summary Returns a list of rule managers that are available to the application
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiMetadataGetRuleManagersGet(
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IStringIEnumerableIRadianseResult> {
      return localVarFp
        .userApiMetadataGetRuleManagersGet(apiVersion, acceptLanguage, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * MetadataApi - object-oriented interface
 * @export
 * @class MetadataApi
 * @extends {BaseAPI}
 */
export class MetadataApi extends BaseAPI {
  /**
   * Permission: metadata_read
   * --TEST
   * @summary Returns a list of rule types that can be handled by the rule manager
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MetadataApi
   */
  public userApiMetadataGetHandledRulesRuleManagerIdGet(
    ruleManagerId: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return MetadataApiFp(this.configuration)
      .userApiMetadataGetHandledRulesRuleManagerIdGet(
        ruleManagerId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: metadata_read
   * --TEST
   * @summary Returns a list of rule managers that are available to the application
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MetadataApi
   */
  public userApiMetadataGetRuleManagersGet(
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return MetadataApiFp(this.configuration)
      .userApiMetadataGetRuleManagersGet(apiVersion, acceptLanguage, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * RequestContextApi - axios parameter creator
 * @export
 */
export const RequestContextApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary
     * @param {string} [requestParameters.apiVersion] The requested API version
     * @param {string} [requestParameters.acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiRequestContextGet: async (
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/RequestContext`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * RequestContextApi - functional programming interface
 * @export
 */
export const RequestContextApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    RequestContextApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * Fp
     * @summary
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiRequestContextGet(
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IIRadianseRequestContext>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiRequestContextGet(
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * RequestContextApi - factory interface
 * @export
 */
export const RequestContextApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = RequestContextApiFp(configuration);
  return {
    /**
     *
     * Factory
     * @summary
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiRequestContextGet(
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IIRadianseRequestContext> {
      return localVarFp
        .userApiRequestContextGet(apiVersion, acceptLanguage, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * RequestContextApi - object-oriented interface
 * @export
 * @class RequestContextApi
 * @extends {BaseAPI}
 */
export class RequestContextApi extends BaseAPI {
  /**
   *
   * --TEST
   * @summary
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RequestContextApi
   */
  public userApiRequestContextGet(
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return RequestContextApiFp(this.configuration)
      .userApiRequestContextGet(apiVersion, acceptLanguage, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * RequirementTypesApi - axios parameter creator
 * @export
 */
export const RequirementTypesApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Permission: requirementtypes_read
     * @summary Get requirement types
     * @param {boolean} [requestParameters.deleted]
     * @param {string} [requestParameters.groupId]
     * @param {string} [requestParameters.tenantId]
     * @param {string} [requestParameters.apiVersion] The requested API version
     * @param {string} [requestParameters.acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiRequirementTypesGet: async (
      deleted?: boolean,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/RequirementTypes`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (deleted !== undefined) {
        localVarQueryParameter["deleted"] = deleted;
      }

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: requirementtypes_delete
     * @summary Delete a requirement type
     * @param {string} requestParameters.id
     * @param {string} [requestParameters.tenantId] TenantId is required if using a bearer token.
     * @param {string} [requestParameters.apiVersion] The requested API version
     * @param {string} [requestParameters.acceptLanguage]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    userApiRequirementTypesIdDelete: async (
      id: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("userApiRequirementTypesIdDelete", "id", id);
      const localVarPath = `/UserApi/RequirementTypes/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: requirementtypes_read
     * @summary Get requirement types by id
     * @param {string} requestParameters.id
     * @param {string} [requestParameters.tenantId] TenantId is required if using a bearer token.
     * @param {string} [requestParameters.apiVersion] The requested API version
     * @param {string} [requestParameters.acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiRequirementTypesIdGet: async (
      id: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("userApiRequirementTypesIdGet", "id", id);
      const localVarPath = `/UserApi/RequirementTypes/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: requirementtypes_create
     * @summary Create or edit a requirement type
     * @param {string} requestParameters.id
     * @param {string} [requestParameters.tenantId] TenantId is required if using a bearer token.
     * @param {string} [requestParameters.apiVersion] The requested API version
     * @param {string} [requestParameters.acceptLanguage]
     * @param {IRequirementTypeVm} [requestParameters.iRequirementTypeVm]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    userApiRequirementTypesIdPut: async (
      id: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iRequirementTypeVm?: IRequirementTypeVm,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("userApiRequirementTypesIdPut", "id", id);
      const localVarPath = `/UserApi/RequirementTypes/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        iRequirementTypeVm,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: requirementtypes_create
     * @summary Create a requirement type
     * @param {string} [requestParameters.tenantId] TenantId is required if using a bearer token.
     * @param {string} [requestParameters.apiVersion] The requested API version
     * @param {string} [requestParameters.acceptLanguage]
     * @param {IRequirementTypeVm} [requestParameters.iRequirementTypeVm]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    userApiRequirementTypesPost: async (
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iRequirementTypeVm?: IRequirementTypeVm,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/RequirementTypes`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        iRequirementTypeVm,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * RequirementTypesApi - functional programming interface
 * @export
 */
export const RequirementTypesApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    RequirementTypesApiAxiosParamCreator(configuration);
  return {
    /**
     * Permission: requirementtypes_read
     * Fp
     * @summary Get requirement types
     * @param {boolean} [deleted]
     * @param {string} [groupId]
     * @param {string} [tenantId]
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiRequirementTypesGet(
      deleted?: boolean,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IRequirementTypeIEnumerableIRadianseResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiRequirementTypesGet(
          deleted,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },

    /**
     * Permission: requirementtypes_delete
     * Fp
     * @summary Delete a requirement type
     * @param {string} id
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async userApiRequirementTypesIdDelete(
      id: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IRequirementTypeIRadianseResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiRequirementTypesIdDelete(
          id,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },

    /**
     * Permission: requirementtypes_read
     * Fp
     * @summary Get requirement types by id
     * @param {string} id
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiRequirementTypesIdGet(
      id: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IRequirementTypeIRadianseResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiRequirementTypesIdGet(
          id,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },

    /**
     * Permission: requirementtypes_create
     * Fp
     * @summary Create or edit a requirement type
     * @param {string} id
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IRequirementTypeVm} [iRequirementTypeVm]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async userApiRequirementTypesIdPut(
      id: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iRequirementTypeVm?: IRequirementTypeVm,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IRequirementTypeIRadianseResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiRequirementTypesIdPut(
          id,
          tenantId,
          apiVersion,
          acceptLanguage,
          iRequirementTypeVm,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },

    /**
     * Permission: requirementtypes_create
     * Fp
     * @summary Create a requirement type
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IRequirementTypeVm} [iRequirementTypeVm]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async userApiRequirementTypesPost(
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iRequirementTypeVm?: IRequirementTypeVm,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IRequirementTypeIRadianseResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiRequirementTypesPost(
          tenantId,
          apiVersion,
          acceptLanguage,
          iRequirementTypeVm,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * RequirementTypesApi - factory interface
 * @export
 */
export const RequirementTypesApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = RequirementTypesApiFp(configuration);
  return {
    /**
     * Permission: requirementtypes_read
     * Factory
     * @summary Get requirement types
     * @param {boolean} [deleted]
     * @param {string} [groupId]
     * @param {string} [tenantId]
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiRequirementTypesGet(
      deleted?: boolean,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IRequirementTypeIEnumerableIRadianseResult> {
      return localVarFp
        .userApiRequirementTypesGet(
          deleted,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: requirementtypes_delete
     * Factory
     * @summary Delete a requirement type
     * @param {string} id
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    userApiRequirementTypesIdDelete(
      id: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IRequirementTypeIRadianseResult> {
      return localVarFp
        .userApiRequirementTypesIdDelete(
          id,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: requirementtypes_read
     * Factory
     * @summary Get requirement types by id
     * @param {string} id
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiRequirementTypesIdGet(
      id: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IRequirementTypeIRadianseResult> {
      return localVarFp
        .userApiRequirementTypesIdGet(
          id,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: requirementtypes_create
     * Factory
     * @summary Create or edit a requirement type
     * @param {string} id
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IRequirementTypeVm} [iRequirementTypeVm]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    userApiRequirementTypesIdPut(
      id: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iRequirementTypeVm?: IRequirementTypeVm,
      options?: any
    ): AxiosPromise<IRequirementTypeIRadianseResult> {
      return localVarFp
        .userApiRequirementTypesIdPut(
          id,
          tenantId,
          apiVersion,
          acceptLanguage,
          iRequirementTypeVm,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: requirementtypes_create
     * Factory
     * @summary Create a requirement type
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IRequirementTypeVm} [iRequirementTypeVm]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    userApiRequirementTypesPost(
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iRequirementTypeVm?: IRequirementTypeVm,
      options?: any
    ): AxiosPromise<IRequirementTypeIRadianseResult> {
      return localVarFp
        .userApiRequirementTypesPost(
          tenantId,
          apiVersion,
          acceptLanguage,
          iRequirementTypeVm,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * RequirementTypesApi - object-oriented interface
 * @export
 * @class RequirementTypesApi
 * @extends {BaseAPI}
 */
export class RequirementTypesApi extends BaseAPI {
  /**
   * Permission: requirementtypes_read
   * --TEST
   * @summary Get requirement types
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RequirementTypesApi
   */
  public userApiRequirementTypesGet(
    deleted?: boolean,
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return RequirementTypesApiFp(this.configuration)
      .userApiRequirementTypesGet(
        deleted,
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: requirementtypes_delete
   * --TEST
   * @summary Delete a requirement type
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof RequirementTypesApi
   */
  public userApiRequirementTypesIdDelete(
    id: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return RequirementTypesApiFp(this.configuration)
      .userApiRequirementTypesIdDelete(
        id,
        tenantId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: requirementtypes_read
   * --TEST
   * @summary Get requirement types by id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RequirementTypesApi
   */
  public userApiRequirementTypesIdGet(
    id: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return RequirementTypesApiFp(this.configuration)
      .userApiRequirementTypesIdGet(
        id,
        tenantId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: requirementtypes_create
   * --TEST
   * @summary Create or edit a requirement type
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof RequirementTypesApi
   */
  public userApiRequirementTypesIdPut(
    id: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    iRequirementTypeVm?: IRequirementTypeVm,
    options?: AxiosRequestConfig
  ) {
    return RequirementTypesApiFp(this.configuration)
      .userApiRequirementTypesIdPut(
        id,
        tenantId,
        apiVersion,
        acceptLanguage,
        iRequirementTypeVm,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: requirementtypes_create
   * --TEST
   * @summary Create a requirement type
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof RequirementTypesApi
   */
  public userApiRequirementTypesPost(
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    iRequirementTypeVm?: IRequirementTypeVm,
    options?: AxiosRequestConfig
  ) {
    return RequirementTypesApiFp(this.configuration)
      .userApiRequirementTypesPost(
        tenantId,
        apiVersion,
        acceptLanguage,
        iRequirementTypeVm,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * RequirementValidationResultsApi - axios parameter creator
 * @export
 */
export const RequirementValidationResultsApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Permission: requirementvalidationresults_read                Scoped to customer
     * @summary Get all requirement validation results
     * @param {IClientTreeType} [requestParameters.clientTreeType] If set to Customer, returns all on customer. If set to Group, returns all in group. If set to Tenant, returns all on tenant. If null, defaults to Tenant
     * @param {string} [requestParameters.firstTimeValue] Query by TimeStamp and apply firstTimeOperator. For example TimeStamp &gt;&#x3D; 2022-11-01.
     * @param {IQueryOperatorType} [requestParameters.firstTimeOperator]
     * @param {string} [requestParameters.secondTimeValue] Query by TimeStamp and apply SecondTimeOperator. For example TimeStamp &lt;&#x3D; 2022-12-01.
     * @param {IQueryOperatorType} [requestParameters.secondTimeOperator]
     * @param {boolean} [requestParameters.deleted] null: get all, true: get deleted, false: get active
     * @param {number} [requestParameters.maxItemCount] The maximum number of items to be retrieved. Defaults to 100.
     * @param {string} [requestParameters.continuationToken] If not null, continues to retrieve the next x items from the last request
     * @param {string} [requestParameters.groupId] GroupId is required if using a bearer token and requesting clientTreeType &#x3D; Group.
     * @param {string} [requestParameters.tenantId] TenantId is required if using a bearer token and requesting clientTreeType &#x3D; Tenant.
     * @param {string} [requestParameters.apiVersion] The requested API version
     * @param {string} [requestParameters.acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiRequirementValidationResultsGet: async (
      clientTreeType?: IClientTreeType,
      firstTimeValue?: string,
      firstTimeOperator?: IQueryOperatorType,
      secondTimeValue?: string,
      secondTimeOperator?: IQueryOperatorType,
      deleted?: boolean,
      maxItemCount?: number,
      continuationToken?: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/RequirementValidationResults`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (clientTreeType !== undefined) {
        localVarQueryParameter["clientTreeType"] = clientTreeType;
      }

      if (firstTimeValue !== undefined) {
        localVarQueryParameter["firstTimeValue"] =
          (firstTimeValue as any) instanceof Date
            ? (firstTimeValue as any).toISOString()
            : firstTimeValue;
      }

      if (firstTimeOperator !== undefined) {
        localVarQueryParameter["firstTimeOperator"] = firstTimeOperator;
      }

      if (secondTimeValue !== undefined) {
        localVarQueryParameter["secondTimeValue"] =
          (secondTimeValue as any) instanceof Date
            ? (secondTimeValue as any).toISOString()
            : secondTimeValue;
      }

      if (secondTimeOperator !== undefined) {
        localVarQueryParameter["secondTimeOperator"] = secondTimeOperator;
      }

      if (deleted !== undefined) {
        localVarQueryParameter["deleted"] = deleted;
      }

      if (maxItemCount !== undefined) {
        localVarQueryParameter["maxItemCount"] = maxItemCount;
      }

      if (continuationToken !== undefined) {
        localVarQueryParameter["continuationToken"] = continuationToken;
      }

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: requirementvalidationresults_delete
     * @summary Delete a validation result
     * @param {string} requestParameters.id
     * @param {string} [requestParameters.apiVersion] The requested API version
     * @param {string} [requestParameters.acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiRequirementValidationResultsIdDelete: async (
      id: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists(
        "userApiRequirementValidationResultsIdDelete",
        "id",
        id
      );
      const localVarPath = `/UserApi/RequirementValidationResults/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: requirementvalidationresults_read
     * @summary Get requirement validation results by id
     * @param {string} requestParameters.id
     * @param {string} [requestParameters.apiVersion] The requested API version
     * @param {string} [requestParameters.acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiRequirementValidationResultsIdGet: async (
      id: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("userApiRequirementValidationResultsIdGet", "id", id);
      const localVarPath = `/UserApi/RequirementValidationResults/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: requirementvalidationresults_create
     * @summary Create or edit a validation result
     * @param {string} requestParameters.id
     * @param {string} [requestParameters.groupId] GroupId is required if using a group bearer token.
     * @param {string} [requestParameters.tenantId] TenantId is required if using a tenant bearer token.
     * @param {string} [requestParameters.apiVersion] The requested API version
     * @param {string} [requestParameters.acceptLanguage]
     * @param {IRequirementValidationResultVm} [requestParameters.iRequirementValidationResultVm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiRequirementValidationResultsIdPut: async (
      id: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iRequirementValidationResultVm?: IRequirementValidationResultVm,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("userApiRequirementValidationResultsIdPut", "id", id);
      const localVarPath = `/UserApi/RequirementValidationResults/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        iRequirementValidationResultVm,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: requirementvalidationresults_edit
     * @summary Override a validation result
     * @param {string} [requestParameters.apiVersion] The requested API version
     * @param {string} [requestParameters.acceptLanguage]
     * @param {IOverRideValidation} [requestParameters.iOverRideValidation]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiRequirementValidationResultsOverrideResultPut: async (
      apiVersion?: string,
      acceptLanguage?: string,
      iOverRideValidation?: IOverRideValidation,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/RequirementValidationResults/OverrideResult`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        iOverRideValidation,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: requirementvalidationresults_create
     * @summary Create a validation result
     * @param {string} [requestParameters.groupId] GroupId is required if using a group bearer token.
     * @param {string} [requestParameters.tenantId] TenantId is required if using a tenant bearer token.
     * @param {string} [requestParameters.apiVersion] The requested API version
     * @param {string} [requestParameters.acceptLanguage]
     * @param {IRequirementValidationResultVm} [requestParameters.iRequirementValidationResultVm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiRequirementValidationResultsPost: async (
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iRequirementValidationResultVm?: IRequirementValidationResultVm,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/RequirementValidationResults`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        iRequirementValidationResultVm,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: requirementvalidationresults_read                Scoped to customer
     * @summary Search all requirement validation results
     * @param {string} [requestParameters.groupId] GroupId is required if using a bearer token and requesting clientTreeType &#x3D; Group.
     * @param {string} [requestParameters.tenantId] TenantId is required if using a bearer token and requesting clientTreeType &#x3D; Tenant.
     * @param {string} [requestParameters.apiVersion] The requested API version
     * @param {string} [requestParameters.acceptLanguage]
     * @param {ISearchRequirementValidationResultsReq} [requestParameters.iSearchRequirementValidationResultsReq] The query to search for rules results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiRequirementValidationResultsSearchPost: async (
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iSearchRequirementValidationResultsReq?: ISearchRequirementValidationResultsReq,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/RequirementValidationResults/Search`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        iSearchRequirementValidationResultsReq,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: requirementvalidationresults_create
     * @summary Validate a list of results
     * @param {string} [requestParameters.apiVersion] The requested API version
     * @param {string} [requestParameters.acceptLanguage]
     * @param {Array<IValidationModel>} [requestParameters.iValidationModel]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiRequirementValidationResultsValidatePost: async (
      apiVersion?: string,
      acceptLanguage?: string,
      iValidationModel?: Array<IValidationModel>,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/RequirementValidationResults/Validate`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        iValidationModel,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: requirementvalidationresults_read
     * @summary Validate a result
     * @param {string} requestParameters.token
     * @param {string} requestParameters.requirementTypeId
     * @param {string} [requestParameters.apiVersion] The requested API version
     * @param {string} [requestParameters.acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiRequirementValidationResultsValidateTokenRequirementTypeIdGet:
      async (
        token: string,
        requirementTypeId: string,
        apiVersion?: string,
        acceptLanguage?: string,
        options: AxiosRequestConfig = {}
      ): Promise<RequestArgs> => {
        // verify required parameter 'token' is not null or undefined
        assertParamExists(
          "userApiRequirementValidationResultsValidateTokenRequirementTypeIdGet",
          "token",
          token
        );
        // verify required parameter 'requirementTypeId' is not null or undefined
        assertParamExists(
          "userApiRequirementValidationResultsValidateTokenRequirementTypeIdGet",
          "requirementTypeId",
          requirementTypeId
        );
        const localVarPath =
          `/UserApi/RequirementValidationResults/Validate/{token}/{requirementTypeId}`
            .replace(`{${"token"}}`, encodeURIComponent(String(token)))
            .replace(
              `{${"requirementTypeId"}}`,
              encodeURIComponent(String(requirementTypeId))
            );
        // use dummy base URL string because the URL constructor only accepts absolute URLs.
        const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
        let baseOptions;
        if (configuration) {
          baseOptions = configuration.baseOptions;
        }

        const localVarRequestOptions = {
          method: "GET",
          ...baseOptions,
          ...options,
        };
        const localVarHeaderParameter = {} as any;
        const localVarQueryParameter = {} as any;

        // authentication Bearer required
        await setApiKeyToObject(
          localVarHeaderParameter,
          "Authorization",
          configuration
        );

        if (apiVersion !== undefined) {
          localVarQueryParameter["api-version"] = apiVersion;
        }

        if (acceptLanguage != null) {
          localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
        }

        setSearchParams(localVarUrlObj, localVarQueryParameter);
        let headersFromBaseOptions =
          baseOptions && baseOptions.headers ? baseOptions.headers : {};
        localVarRequestOptions.headers = {
          ...localVarHeaderParameter,
          ...headersFromBaseOptions,
          ...options.headers,
        };

        return {
          url: toPathString(localVarUrlObj),
          options: localVarRequestOptions,
        };
      },
  };
};

/**
 * RequirementValidationResultsApi - functional programming interface
 * @export
 */
export const RequirementValidationResultsApiFp = function (
  configuration?: Configuration
) {
  const localVarAxiosParamCreator =
    RequirementValidationResultsApiAxiosParamCreator(configuration);
  return {
    /**
     * Permission: requirementvalidationresults_read                Scoped to customer
     * Fp
     * @summary Get all requirement validation results
     * @param {IClientTreeType} [clientTreeType] If set to Customer, returns all on customer. If set to Group, returns all in group. If set to Tenant, returns all on tenant. If null, defaults to Tenant
     * @param {string} [firstTimeValue] Query by TimeStamp and apply firstTimeOperator. For example TimeStamp &gt;&#x3D; 2022-11-01.
     * @param {IQueryOperatorType} [firstTimeOperator]
     * @param {string} [secondTimeValue] Query by TimeStamp and apply SecondTimeOperator. For example TimeStamp &lt;&#x3D; 2022-12-01.
     * @param {IQueryOperatorType} [secondTimeOperator]
     * @param {boolean} [deleted] null: get all, true: get deleted, false: get active
     * @param {number} [maxItemCount] The maximum number of items to be retrieved. Defaults to 100.
     * @param {string} [continuationToken] If not null, continues to retrieve the next x items from the last request
     * @param {string} [groupId] GroupId is required if using a bearer token and requesting clientTreeType &#x3D; Group.
     * @param {string} [tenantId] TenantId is required if using a bearer token and requesting clientTreeType &#x3D; Tenant.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiRequirementValidationResultsGet(
      clientTreeType?: IClientTreeType,
      firstTimeValue?: string,
      firstTimeOperator?: IQueryOperatorType,
      secondTimeValue?: string,
      secondTimeOperator?: IQueryOperatorType,
      deleted?: boolean,
      maxItemCount?: number,
      continuationToken?: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IRequirementValidationResultListIRadianseResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiRequirementValidationResultsGet(
          clientTreeType,
          firstTimeValue,
          firstTimeOperator,
          secondTimeValue,
          secondTimeOperator,
          deleted,
          maxItemCount,
          continuationToken,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },

    /**
     * Permission: requirementvalidationresults_delete
     * Fp
     * @summary Delete a validation result
     * @param {string} id
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiRequirementValidationResultsIdDelete(
      id: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IRequirementValidationResultIRadianseResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiRequirementValidationResultsIdDelete(
          id,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },

    /**
     * Permission: requirementvalidationresults_read
     * Fp
     * @summary Get requirement validation results by id
     * @param {string} id
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiRequirementValidationResultsIdGet(
      id: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IRequirementValidationResultIRadianseResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiRequirementValidationResultsIdGet(
          id,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },

    /**
     * Permission: requirementvalidationresults_create
     * Fp
     * @summary Create or edit a validation result
     * @param {string} id
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a tenant bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IRequirementValidationResultVm} [iRequirementValidationResultVm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiRequirementValidationResultsIdPut(
      id: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iRequirementValidationResultVm?: IRequirementValidationResultVm,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IRequirementValidationResultIRadianseResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiRequirementValidationResultsIdPut(
          id,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          iRequirementValidationResultVm,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },

    /**
     * Permission: requirementvalidationresults_edit
     * Fp
     * @summary Override a validation result
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IOverRideValidation} [iOverRideValidation]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiRequirementValidationResultsOverrideResultPut(
      apiVersion?: string,
      acceptLanguage?: string,
      iOverRideValidation?: IOverRideValidation,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IRequirementValidationResultIRadianseResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiRequirementValidationResultsOverrideResultPut(
          apiVersion,
          acceptLanguage,
          iOverRideValidation,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },

    /**
     * Permission: requirementvalidationresults_create
     * Fp
     * @summary Create a validation result
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a tenant bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IRequirementValidationResultVm} [iRequirementValidationResultVm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiRequirementValidationResultsPost(
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iRequirementValidationResultVm?: IRequirementValidationResultVm,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IRequirementValidationResultIRadianseResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiRequirementValidationResultsPost(
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          iRequirementValidationResultVm,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },

    /**
     * Permission: requirementvalidationresults_read                Scoped to customer
     * Fp
     * @summary Search all requirement validation results
     * @param {string} [groupId] GroupId is required if using a bearer token and requesting clientTreeType &#x3D; Group.
     * @param {string} [tenantId] TenantId is required if using a bearer token and requesting clientTreeType &#x3D; Tenant.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {ISearchRequirementValidationResultsReq} [iSearchRequirementValidationResultsReq] The query to search for rules results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiRequirementValidationResultsSearchPost(
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iSearchRequirementValidationResultsReq?: ISearchRequirementValidationResultsReq,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IRequirementValidationResultListIRadianseResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiRequirementValidationResultsSearchPost(
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          iSearchRequirementValidationResultsReq,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },

    /**
     * Permission: requirementvalidationresults_create
     * Fp
     * @summary Validate a list of results
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {Array<IValidationModel>} [iValidationModel]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiRequirementValidationResultsValidatePost(
      apiVersion?: string,
      acceptLanguage?: string,
      iValidationModel?: Array<IValidationModel>,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IValidationResponseListIRadianseResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiRequirementValidationResultsValidatePost(
          apiVersion,
          acceptLanguage,
          iValidationModel,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },

    /**
     * Permission: requirementvalidationresults_read
     * Fp
     * @summary Validate a result
     * @param {string} token
     * @param {string} requirementTypeId
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiRequirementValidationResultsValidateTokenRequirementTypeIdGet(
      token: string,
      requirementTypeId: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IValidationResponseIRadianseResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiRequirementValidationResultsValidateTokenRequirementTypeIdGet(
          token,
          requirementTypeId,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * RequirementValidationResultsApi - factory interface
 * @export
 */
export const RequirementValidationResultsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = RequirementValidationResultsApiFp(configuration);
  return {
    /**
     * Permission: requirementvalidationresults_read                Scoped to customer
     * Factory
     * @summary Get all requirement validation results
     * @param {IClientTreeType} [clientTreeType] If set to Customer, returns all on customer. If set to Group, returns all in group. If set to Tenant, returns all on tenant. If null, defaults to Tenant
     * @param {string} [firstTimeValue] Query by TimeStamp and apply firstTimeOperator. For example TimeStamp &gt;&#x3D; 2022-11-01.
     * @param {IQueryOperatorType} [firstTimeOperator]
     * @param {string} [secondTimeValue] Query by TimeStamp and apply SecondTimeOperator. For example TimeStamp &lt;&#x3D; 2022-12-01.
     * @param {IQueryOperatorType} [secondTimeOperator]
     * @param {boolean} [deleted] null: get all, true: get deleted, false: get active
     * @param {number} [maxItemCount] The maximum number of items to be retrieved. Defaults to 100.
     * @param {string} [continuationToken] If not null, continues to retrieve the next x items from the last request
     * @param {string} [groupId] GroupId is required if using a bearer token and requesting clientTreeType &#x3D; Group.
     * @param {string} [tenantId] TenantId is required if using a bearer token and requesting clientTreeType &#x3D; Tenant.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiRequirementValidationResultsGet(
      clientTreeType?: IClientTreeType,
      firstTimeValue?: string,
      firstTimeOperator?: IQueryOperatorType,
      secondTimeValue?: string,
      secondTimeOperator?: IQueryOperatorType,
      deleted?: boolean,
      maxItemCount?: number,
      continuationToken?: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IRequirementValidationResultListIRadianseResult> {
      return localVarFp
        .userApiRequirementValidationResultsGet(
          clientTreeType,
          firstTimeValue,
          firstTimeOperator,
          secondTimeValue,
          secondTimeOperator,
          deleted,
          maxItemCount,
          continuationToken,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: requirementvalidationresults_delete
     * Factory
     * @summary Delete a validation result
     * @param {string} id
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiRequirementValidationResultsIdDelete(
      id: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IRequirementValidationResultIRadianseResult> {
      return localVarFp
        .userApiRequirementValidationResultsIdDelete(
          id,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: requirementvalidationresults_read
     * Factory
     * @summary Get requirement validation results by id
     * @param {string} id
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiRequirementValidationResultsIdGet(
      id: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IRequirementValidationResultIRadianseResult> {
      return localVarFp
        .userApiRequirementValidationResultsIdGet(
          id,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: requirementvalidationresults_create
     * Factory
     * @summary Create or edit a validation result
     * @param {string} id
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a tenant bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IRequirementValidationResultVm} [iRequirementValidationResultVm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiRequirementValidationResultsIdPut(
      id: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iRequirementValidationResultVm?: IRequirementValidationResultVm,
      options?: any
    ): AxiosPromise<IRequirementValidationResultIRadianseResult> {
      return localVarFp
        .userApiRequirementValidationResultsIdPut(
          id,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          iRequirementValidationResultVm,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: requirementvalidationresults_edit
     * Factory
     * @summary Override a validation result
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IOverRideValidation} [iOverRideValidation]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiRequirementValidationResultsOverrideResultPut(
      apiVersion?: string,
      acceptLanguage?: string,
      iOverRideValidation?: IOverRideValidation,
      options?: any
    ): AxiosPromise<IRequirementValidationResultIRadianseResult> {
      return localVarFp
        .userApiRequirementValidationResultsOverrideResultPut(
          apiVersion,
          acceptLanguage,
          iOverRideValidation,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: requirementvalidationresults_create
     * Factory
     * @summary Create a validation result
     * @param {string} [groupId] GroupId is required if using a group bearer token.
     * @param {string} [tenantId] TenantId is required if using a tenant bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IRequirementValidationResultVm} [iRequirementValidationResultVm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiRequirementValidationResultsPost(
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iRequirementValidationResultVm?: IRequirementValidationResultVm,
      options?: any
    ): AxiosPromise<IRequirementValidationResultIRadianseResult> {
      return localVarFp
        .userApiRequirementValidationResultsPost(
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          iRequirementValidationResultVm,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: requirementvalidationresults_read                Scoped to customer
     * Factory
     * @summary Search all requirement validation results
     * @param {string} [groupId] GroupId is required if using a bearer token and requesting clientTreeType &#x3D; Group.
     * @param {string} [tenantId] TenantId is required if using a bearer token and requesting clientTreeType &#x3D; Tenant.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {ISearchRequirementValidationResultsReq} [iSearchRequirementValidationResultsReq] The query to search for rules results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiRequirementValidationResultsSearchPost(
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iSearchRequirementValidationResultsReq?: ISearchRequirementValidationResultsReq,
      options?: any
    ): AxiosPromise<IRequirementValidationResultListIRadianseResult> {
      return localVarFp
        .userApiRequirementValidationResultsSearchPost(
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          iSearchRequirementValidationResultsReq,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: requirementvalidationresults_create
     * Factory
     * @summary Validate a list of results
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {Array<IValidationModel>} [iValidationModel]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiRequirementValidationResultsValidatePost(
      apiVersion?: string,
      acceptLanguage?: string,
      iValidationModel?: Array<IValidationModel>,
      options?: any
    ): AxiosPromise<IValidationResponseListIRadianseResult> {
      return localVarFp
        .userApiRequirementValidationResultsValidatePost(
          apiVersion,
          acceptLanguage,
          iValidationModel,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: requirementvalidationresults_read
     * Factory
     * @summary Validate a result
     * @param {string} token
     * @param {string} requirementTypeId
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiRequirementValidationResultsValidateTokenRequirementTypeIdGet(
      token: string,
      requirementTypeId: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IValidationResponseIRadianseResult> {
      return localVarFp
        .userApiRequirementValidationResultsValidateTokenRequirementTypeIdGet(
          token,
          requirementTypeId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * RequirementValidationResultsApi - object-oriented interface
 * @export
 * @class RequirementValidationResultsApi
 * @extends {BaseAPI}
 */
export class RequirementValidationResultsApi extends BaseAPI {
  /**
   * Permission: requirementvalidationresults_read                Scoped to customer
   * --TEST
   * @summary Get all requirement validation results
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RequirementValidationResultsApi
   */
  public userApiRequirementValidationResultsGet(
    clientTreeType?: IClientTreeType,
    firstTimeValue?: string,
    firstTimeOperator?: IQueryOperatorType,
    secondTimeValue?: string,
    secondTimeOperator?: IQueryOperatorType,
    deleted?: boolean,
    maxItemCount?: number,
    continuationToken?: string,
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return RequirementValidationResultsApiFp(this.configuration)
      .userApiRequirementValidationResultsGet(
        clientTreeType,
        firstTimeValue,
        firstTimeOperator,
        secondTimeValue,
        secondTimeOperator,
        deleted,
        maxItemCount,
        continuationToken,
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: requirementvalidationresults_delete
   * --TEST
   * @summary Delete a validation result
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RequirementValidationResultsApi
   */
  public userApiRequirementValidationResultsIdDelete(
    id: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return RequirementValidationResultsApiFp(this.configuration)
      .userApiRequirementValidationResultsIdDelete(
        id,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: requirementvalidationresults_read
   * --TEST
   * @summary Get requirement validation results by id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RequirementValidationResultsApi
   */
  public userApiRequirementValidationResultsIdGet(
    id: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return RequirementValidationResultsApiFp(this.configuration)
      .userApiRequirementValidationResultsIdGet(
        id,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: requirementvalidationresults_create
   * --TEST
   * @summary Create or edit a validation result
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RequirementValidationResultsApi
   */
  public userApiRequirementValidationResultsIdPut(
    id: string,
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    iRequirementValidationResultVm?: IRequirementValidationResultVm,
    options?: AxiosRequestConfig
  ) {
    return RequirementValidationResultsApiFp(this.configuration)
      .userApiRequirementValidationResultsIdPut(
        id,
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        iRequirementValidationResultVm,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: requirementvalidationresults_edit
   * --TEST
   * @summary Override a validation result
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RequirementValidationResultsApi
   */
  public userApiRequirementValidationResultsOverrideResultPut(
    apiVersion?: string,
    acceptLanguage?: string,
    iOverRideValidation?: IOverRideValidation,
    options?: AxiosRequestConfig
  ) {
    return RequirementValidationResultsApiFp(this.configuration)
      .userApiRequirementValidationResultsOverrideResultPut(
        apiVersion,
        acceptLanguage,
        iOverRideValidation,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: requirementvalidationresults_create
   * --TEST
   * @summary Create a validation result
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RequirementValidationResultsApi
   */
  public userApiRequirementValidationResultsPost(
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    iRequirementValidationResultVm?: IRequirementValidationResultVm,
    options?: AxiosRequestConfig
  ) {
    return RequirementValidationResultsApiFp(this.configuration)
      .userApiRequirementValidationResultsPost(
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        iRequirementValidationResultVm,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: requirementvalidationresults_read                Scoped to customer
   * --TEST
   * @summary Search all requirement validation results
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RequirementValidationResultsApi
   */
  public userApiRequirementValidationResultsSearchPost(
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    iSearchRequirementValidationResultsReq?: ISearchRequirementValidationResultsReq,
    options?: AxiosRequestConfig
  ) {
    return RequirementValidationResultsApiFp(this.configuration)
      .userApiRequirementValidationResultsSearchPost(
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        iSearchRequirementValidationResultsReq,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: requirementvalidationresults_create
   * --TEST
   * @summary Validate a list of results
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RequirementValidationResultsApi
   */
  public userApiRequirementValidationResultsValidatePost(
    apiVersion?: string,
    acceptLanguage?: string,
    iValidationModel?: Array<IValidationModel>,
    options?: AxiosRequestConfig
  ) {
    return RequirementValidationResultsApiFp(this.configuration)
      .userApiRequirementValidationResultsValidatePost(
        apiVersion,
        acceptLanguage,
        iValidationModel,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: requirementvalidationresults_read
   * --TEST
   * @summary Validate a result
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RequirementValidationResultsApi
   */
  public userApiRequirementValidationResultsValidateTokenRequirementTypeIdGet(
    token: string,
    requirementTypeId: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return RequirementValidationResultsApiFp(this.configuration)
      .userApiRequirementValidationResultsValidateTokenRequirementTypeIdGet(
        token,
        requirementTypeId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * RuleConfigurationsApi - axios parameter creator
 * @export
 */
export const RuleConfigurationsApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Permission: ruleconfigurations_read
     * @summary Get ConditionallyRequiredDocument Id and names
     * @param {boolean} [requestParameters.forceReread] If true, read from database. If false, read from cache.
     * @param {string} [requestParameters.apiVersion] The requested API version
     * @param {string} [requestParameters.acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiRuleConfigurationsConditionallyRequiredDocumentIdsGet: async (
      forceReread?: boolean,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/RuleConfigurations/ConditionallyRequiredDocument/Ids`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (forceReread !== undefined) {
        localVarQueryParameter["forceReread"] = forceReread;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: ruleconfigurations_read
     * @summary Get all rule configurations. Results are scoped to customer.
     * @param {boolean} [requestParameters.deleted]
     * @param {string} [requestParameters.apiVersion] The requested API version
     * @param {string} [requestParameters.acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiRuleConfigurationsGet: async (
      deleted?: boolean,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/RuleConfigurations`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (deleted !== undefined) {
        localVarQueryParameter["deleted"] = deleted;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: ruleconfigurations_delete
     * @summary Delete a rule configuration
     * @param {string} requestParameters.id
     * @param {string} [requestParameters.apiVersion] The requested API version
     * @param {string} [requestParameters.acceptLanguage]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    userApiRuleConfigurationsIdDelete: async (
      id: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("userApiRuleConfigurationsIdDelete", "id", id);
      const localVarPath = `/UserApi/RuleConfigurations/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: ruleconfigurations_read
     * @summary Get a rule configuration by id
     * @param {string} requestParameters.id Rule configuration ID
     * @param {string} [requestParameters.apiVersion] The requested API version
     * @param {string} [requestParameters.acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiRuleConfigurationsIdGet: async (
      id: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("userApiRuleConfigurationsIdGet", "id", id);
      const localVarPath = `/UserApi/RuleConfigurations/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: ruleconfigurations_create
     * @summary Create or edit a rule configuration
     * @param {string} requestParameters.id
     * @param {string} [requestParameters.apiVersion] The requested API version
     * @param {string} [requestParameters.acceptLanguage]
     * @param {IRuleConfigurationVm} [requestParameters.iRuleConfigurationVm]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    userApiRuleConfigurationsIdPut: async (
      id: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iRuleConfigurationVm?: IRuleConfigurationVm,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("userApiRuleConfigurationsIdPut", "id", id);
      const localVarPath = `/UserApi/RuleConfigurations/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        iRuleConfigurationVm,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: ruleconfigurations_create
     * @summary Set the configurable rules. These would be allowed min/max values, required documents, etc..
     * @param {string} [requestParameters.apiVersion] The requested API version
     * @param {string} [requestParameters.acceptLanguage]
     * @param {IRuleConfigurationVm} [requestParameters.iRuleConfigurationVm]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    userApiRuleConfigurationsPost: async (
      apiVersion?: string,
      acceptLanguage?: string,
      iRuleConfigurationVm?: IRuleConfigurationVm,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/RuleConfigurations`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        iRuleConfigurationVm,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: ruleconfigurations_read
     * @summary Get possible values that can exist in ruleFailures names RequirementValidationResults
     * @param {boolean} [requestParameters.forceReread] If true, read from database. If false, read from cache.
     * @param {string} [requestParameters.apiVersion] The requested API version
     * @param {string} [requestParameters.acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiRuleConfigurationsRuleFailureNamesGet: async (
      forceReread?: boolean,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/RuleConfigurations/RuleFailureNames`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (forceReread !== undefined) {
        localVarQueryParameter["forceReread"] = forceReread;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * RuleConfigurationsApi - functional programming interface
 * @export
 */
export const RuleConfigurationsApiFp = function (
  configuration?: Configuration
) {
  const localVarAxiosParamCreator =
    RuleConfigurationsApiAxiosParamCreator(configuration);
  return {
    /**
     * Permission: ruleconfigurations_read
     * Fp
     * @summary Get ConditionallyRequiredDocument Id and names
     * @param {boolean} [forceReread] If true, read from database. If false, read from cache.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiRuleConfigurationsConditionallyRequiredDocumentIdsGet(
      forceReread?: boolean,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IIdAndNameListIRadianseResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiRuleConfigurationsConditionallyRequiredDocumentIdsGet(
          forceReread,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },

    /**
     * Permission: ruleconfigurations_read
     * Fp
     * @summary Get all rule configurations. Results are scoped to customer.
     * @param {boolean} [deleted]
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiRuleConfigurationsGet(
      deleted?: boolean,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IRuleConfigurationListIRadianseResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiRuleConfigurationsGet(
          deleted,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },

    /**
     * Permission: ruleconfigurations_delete
     * Fp
     * @summary Delete a rule configuration
     * @param {string} id
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async userApiRuleConfigurationsIdDelete(
      id: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IRuleConfigurationIRadianseResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiRuleConfigurationsIdDelete(
          id,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },

    /**
     * Permission: ruleconfigurations_read
     * Fp
     * @summary Get a rule configuration by id
     * @param {string} id Rule configuration ID
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiRuleConfigurationsIdGet(
      id: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IRuleConfigurationIRadianseResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiRuleConfigurationsIdGet(
          id,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },

    /**
     * Permission: ruleconfigurations_create
     * Fp
     * @summary Create or edit a rule configuration
     * @param {string} id
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IRuleConfigurationVm} [iRuleConfigurationVm]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async userApiRuleConfigurationsIdPut(
      id: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iRuleConfigurationVm?: IRuleConfigurationVm,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IRuleConfigurationIRadianseResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiRuleConfigurationsIdPut(
          id,
          apiVersion,
          acceptLanguage,
          iRuleConfigurationVm,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },

    /**
     * Permission: ruleconfigurations_create
     * Fp
     * @summary Set the configurable rules. These would be allowed min/max values, required documents, etc..
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IRuleConfigurationVm} [iRuleConfigurationVm]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async userApiRuleConfigurationsPost(
      apiVersion?: string,
      acceptLanguage?: string,
      iRuleConfigurationVm?: IRuleConfigurationVm,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IRuleConfigurationIRadianseResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiRuleConfigurationsPost(
          apiVersion,
          acceptLanguage,
          iRuleConfigurationVm,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },

    /**
     * Permission: ruleconfigurations_read
     * Fp
     * @summary Get possible values that can exist in ruleFailures names RequirementValidationResults
     * @param {boolean} [forceReread] If true, read from database. If false, read from cache.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiRuleConfigurationsRuleFailureNamesGet(
      forceReread?: boolean,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IStringListIRadianseResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiRuleConfigurationsRuleFailureNamesGet(
          forceReread,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * RuleConfigurationsApi - factory interface
 * @export
 */
export const RuleConfigurationsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = RuleConfigurationsApiFp(configuration);
  return {
    /**
     * Permission: ruleconfigurations_read
     * Factory
     * @summary Get ConditionallyRequiredDocument Id and names
     * @param {boolean} [forceReread] If true, read from database. If false, read from cache.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiRuleConfigurationsConditionallyRequiredDocumentIdsGet(
      forceReread?: boolean,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IIdAndNameListIRadianseResult> {
      return localVarFp
        .userApiRuleConfigurationsConditionallyRequiredDocumentIdsGet(
          forceReread,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: ruleconfigurations_read
     * Factory
     * @summary Get all rule configurations. Results are scoped to customer.
     * @param {boolean} [deleted]
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiRuleConfigurationsGet(
      deleted?: boolean,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IRuleConfigurationListIRadianseResult> {
      return localVarFp
        .userApiRuleConfigurationsGet(
          deleted,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: ruleconfigurations_delete
     * Factory
     * @summary Delete a rule configuration
     * @param {string} id
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    userApiRuleConfigurationsIdDelete(
      id: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IRuleConfigurationIRadianseResult> {
      return localVarFp
        .userApiRuleConfigurationsIdDelete(
          id,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: ruleconfigurations_read
     * Factory
     * @summary Get a rule configuration by id
     * @param {string} id Rule configuration ID
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiRuleConfigurationsIdGet(
      id: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IRuleConfigurationIRadianseResult> {
      return localVarFp
        .userApiRuleConfigurationsIdGet(id, apiVersion, acceptLanguage, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: ruleconfigurations_create
     * Factory
     * @summary Create or edit a rule configuration
     * @param {string} id
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IRuleConfigurationVm} [iRuleConfigurationVm]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    userApiRuleConfigurationsIdPut(
      id: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iRuleConfigurationVm?: IRuleConfigurationVm,
      options?: any
    ): AxiosPromise<IRuleConfigurationIRadianseResult> {
      return localVarFp
        .userApiRuleConfigurationsIdPut(
          id,
          apiVersion,
          acceptLanguage,
          iRuleConfigurationVm,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: ruleconfigurations_create
     * Factory
     * @summary Set the configurable rules. These would be allowed min/max values, required documents, etc..
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IRuleConfigurationVm} [iRuleConfigurationVm]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    userApiRuleConfigurationsPost(
      apiVersion?: string,
      acceptLanguage?: string,
      iRuleConfigurationVm?: IRuleConfigurationVm,
      options?: any
    ): AxiosPromise<IRuleConfigurationIRadianseResult> {
      return localVarFp
        .userApiRuleConfigurationsPost(
          apiVersion,
          acceptLanguage,
          iRuleConfigurationVm,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: ruleconfigurations_read
     * Factory
     * @summary Get possible values that can exist in ruleFailures names RequirementValidationResults
     * @param {boolean} [forceReread] If true, read from database. If false, read from cache.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiRuleConfigurationsRuleFailureNamesGet(
      forceReread?: boolean,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IStringListIRadianseResult> {
      return localVarFp
        .userApiRuleConfigurationsRuleFailureNamesGet(
          forceReread,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * RuleConfigurationsApi - object-oriented interface
 * @export
 * @class RuleConfigurationsApi
 * @extends {BaseAPI}
 */
export class RuleConfigurationsApi extends BaseAPI {
  /**
   * Permission: ruleconfigurations_read
   * --TEST
   * @summary Get ConditionallyRequiredDocument Id and names
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RuleConfigurationsApi
   */
  public userApiRuleConfigurationsConditionallyRequiredDocumentIdsGet(
    forceReread?: boolean,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return RuleConfigurationsApiFp(this.configuration)
      .userApiRuleConfigurationsConditionallyRequiredDocumentIdsGet(
        forceReread,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: ruleconfigurations_read
   * --TEST
   * @summary Get all rule configurations. Results are scoped to customer.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RuleConfigurationsApi
   */
  public userApiRuleConfigurationsGet(
    deleted?: boolean,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return RuleConfigurationsApiFp(this.configuration)
      .userApiRuleConfigurationsGet(
        deleted,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: ruleconfigurations_delete
   * --TEST
   * @summary Delete a rule configuration
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof RuleConfigurationsApi
   */
  public userApiRuleConfigurationsIdDelete(
    id: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return RuleConfigurationsApiFp(this.configuration)
      .userApiRuleConfigurationsIdDelete(
        id,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: ruleconfigurations_read
   * --TEST
   * @summary Get a rule configuration by id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RuleConfigurationsApi
   */
  public userApiRuleConfigurationsIdGet(
    id: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return RuleConfigurationsApiFp(this.configuration)
      .userApiRuleConfigurationsIdGet(id, apiVersion, acceptLanguage, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: ruleconfigurations_create
   * --TEST
   * @summary Create or edit a rule configuration
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof RuleConfigurationsApi
   */
  public userApiRuleConfigurationsIdPut(
    id: string,
    apiVersion?: string,
    acceptLanguage?: string,
    iRuleConfigurationVm?: IRuleConfigurationVm,
    options?: AxiosRequestConfig
  ) {
    return RuleConfigurationsApiFp(this.configuration)
      .userApiRuleConfigurationsIdPut(
        id,
        apiVersion,
        acceptLanguage,
        iRuleConfigurationVm,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: ruleconfigurations_create
   * --TEST
   * @summary Set the configurable rules. These would be allowed min/max values, required documents, etc..
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof RuleConfigurationsApi
   */
  public userApiRuleConfigurationsPost(
    apiVersion?: string,
    acceptLanguage?: string,
    iRuleConfigurationVm?: IRuleConfigurationVm,
    options?: AxiosRequestConfig
  ) {
    return RuleConfigurationsApiFp(this.configuration)
      .userApiRuleConfigurationsPost(
        apiVersion,
        acceptLanguage,
        iRuleConfigurationVm,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: ruleconfigurations_read
   * --TEST
   * @summary Get possible values that can exist in ruleFailures names RequirementValidationResults
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RuleConfigurationsApi
   */
  public userApiRuleConfigurationsRuleFailureNamesGet(
    forceReread?: boolean,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return RuleConfigurationsApiFp(this.configuration)
      .userApiRuleConfigurationsRuleFailureNamesGet(
        forceReread,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * RuleEvaluatorApi - axios parameter creator
 * @export
 */
export const RuleEvaluatorApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Permission: ruleevaluator_create
     * @summary Lists all the cached data for the RuleEvaluator.
     * @param {string} [requestParameters.tenantId] TenantId is required if using a bearer token. This would be the tenant the resources are associated with.
     * @param {string} [requestParameters.apiVersion] The requested API version
     * @param {string} [requestParameters.acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiRuleEvaluatorCacheGet: async (
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/RuleEvaluator/Cache`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: ruleevaluator_create
     * @summary Evaluate rules and requirements pass or fail.
     * @param {string} [requestParameters.tenantId] TenantId is required if using a bearer token. This would be the tenant the resources are associated with.
     * @param {string} [requestParameters.apiVersion] The requested API version
     * @param {string} [requestParameters.acceptLanguage]
     * @param {IRuleEvaluatorVm} [requestParameters.iRuleEvaluatorVm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiRuleEvaluatorPost: async (
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iRuleEvaluatorVm?: IRuleEvaluatorVm,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/RuleEvaluator`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        iRuleEvaluatorVm,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: ruleevaluator_create
     * @summary Refresh the Rules cache
     * @param {string} [requestParameters.tenantId] TenantId is required if using a bearer token. This would be the tenant the resources are associated with.
     * @param {string} [requestParameters.apiVersion] The requested API version
     * @param {string} [requestParameters.acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiRuleEvaluatorRefreshPost: async (
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/RuleEvaluator/Refresh`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: ruleevaluator_create
     * @summary Lists all the cached data for the RuleEvaluator.
     * @param {string} [requestParameters.tenantId] TenantId is required if using a bearer token. This would be the tenant the resources are associated with.
     * @param {string} [requestParameters.apiVersion] The requested API version
     * @param {string} [requestParameters.acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiRuleEvaluatorStatusGet: async (
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/RuleEvaluator/Status`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * RuleEvaluatorApi - functional programming interface
 * @export
 */
export const RuleEvaluatorApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    RuleEvaluatorApiAxiosParamCreator(configuration);
  return {
    /**
     * Permission: ruleevaluator_create
     * Fp
     * @summary Lists all the cached data for the RuleEvaluator.
     * @param {string} [tenantId] TenantId is required if using a bearer token. This would be the tenant the resources are associated with.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiRuleEvaluatorCacheGet(
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IRuleEquipmentInfoListIRadianseResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiRuleEvaluatorCacheGet(
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },

    /**
     * Permission: ruleevaluator_create
     * Fp
     * @summary Evaluate rules and requirements pass or fail.
     * @param {string} [tenantId] TenantId is required if using a bearer token. This would be the tenant the resources are associated with.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IRuleEvaluatorVm} [iRuleEvaluatorVm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiRuleEvaluatorPost(
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iRuleEvaluatorVm?: IRuleEvaluatorVm,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IRequirementValidationResultIRadianseResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiRuleEvaluatorPost(
          tenantId,
          apiVersion,
          acceptLanguage,
          iRuleEvaluatorVm,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },

    /**
     * Permission: ruleevaluator_create
     * Fp
     * @summary Refresh the Rules cache
     * @param {string} [tenantId] TenantId is required if using a bearer token. This would be the tenant the resources are associated with.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiRuleEvaluatorRefreshPost(
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IRuleEquipmentInfoListIRadianseResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiRuleEvaluatorRefreshPost(
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },

    /**
     * Permission: ruleevaluator_create
     * Fp
     * @summary Lists all the cached data for the RuleEvaluator.
     * @param {string} [tenantId] TenantId is required if using a bearer token. This would be the tenant the resources are associated with.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiRuleEvaluatorStatusGet(
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IRuleCacheStatusIRadianseResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiRuleEvaluatorStatusGet(
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * RuleEvaluatorApi - factory interface
 * @export
 */
export const RuleEvaluatorApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = RuleEvaluatorApiFp(configuration);
  return {
    /**
     * Permission: ruleevaluator_create
     * Factory
     * @summary Lists all the cached data for the RuleEvaluator.
     * @param {string} [tenantId] TenantId is required if using a bearer token. This would be the tenant the resources are associated with.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiRuleEvaluatorCacheGet(
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IRuleEquipmentInfoListIRadianseResult> {
      return localVarFp
        .userApiRuleEvaluatorCacheGet(
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: ruleevaluator_create
     * Factory
     * @summary Evaluate rules and requirements pass or fail.
     * @param {string} [tenantId] TenantId is required if using a bearer token. This would be the tenant the resources are associated with.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IRuleEvaluatorVm} [iRuleEvaluatorVm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiRuleEvaluatorPost(
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iRuleEvaluatorVm?: IRuleEvaluatorVm,
      options?: any
    ): AxiosPromise<IRequirementValidationResultIRadianseResult> {
      return localVarFp
        .userApiRuleEvaluatorPost(
          tenantId,
          apiVersion,
          acceptLanguage,
          iRuleEvaluatorVm,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: ruleevaluator_create
     * Factory
     * @summary Refresh the Rules cache
     * @param {string} [tenantId] TenantId is required if using a bearer token. This would be the tenant the resources are associated with.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiRuleEvaluatorRefreshPost(
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IRuleEquipmentInfoListIRadianseResult> {
      return localVarFp
        .userApiRuleEvaluatorRefreshPost(
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: ruleevaluator_create
     * Factory
     * @summary Lists all the cached data for the RuleEvaluator.
     * @param {string} [tenantId] TenantId is required if using a bearer token. This would be the tenant the resources are associated with.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiRuleEvaluatorStatusGet(
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IRuleCacheStatusIRadianseResult> {
      return localVarFp
        .userApiRuleEvaluatorStatusGet(
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * RuleEvaluatorApi - object-oriented interface
 * @export
 * @class RuleEvaluatorApi
 * @extends {BaseAPI}
 */
export class RuleEvaluatorApi extends BaseAPI {
  /**
   * Permission: ruleevaluator_create
   * --TEST
   * @summary Lists all the cached data for the RuleEvaluator.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RuleEvaluatorApi
   */
  public userApiRuleEvaluatorCacheGet(
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return RuleEvaluatorApiFp(this.configuration)
      .userApiRuleEvaluatorCacheGet(
        tenantId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: ruleevaluator_create
   * --TEST
   * @summary Evaluate rules and requirements pass or fail.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RuleEvaluatorApi
   */
  public userApiRuleEvaluatorPost(
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    iRuleEvaluatorVm?: IRuleEvaluatorVm,
    options?: AxiosRequestConfig
  ) {
    return RuleEvaluatorApiFp(this.configuration)
      .userApiRuleEvaluatorPost(
        tenantId,
        apiVersion,
        acceptLanguage,
        iRuleEvaluatorVm,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: ruleevaluator_create
   * --TEST
   * @summary Refresh the Rules cache
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RuleEvaluatorApi
   */
  public userApiRuleEvaluatorRefreshPost(
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return RuleEvaluatorApiFp(this.configuration)
      .userApiRuleEvaluatorRefreshPost(
        tenantId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: ruleevaluator_create
   * --TEST
   * @summary Lists all the cached data for the RuleEvaluator.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RuleEvaluatorApi
   */
  public userApiRuleEvaluatorStatusGet(
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return RuleEvaluatorApiFp(this.configuration)
      .userApiRuleEvaluatorStatusGet(
        tenantId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * RuleGroupsApi - axios parameter creator
 * @export
 */
export const RuleGroupsApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Permission: rulegroups_read
     * @summary Get rule groups
     * @param {boolean} [requestParameters.deleted]
     * @param {string} [requestParameters.apiVersion] The requested API version
     * @param {string} [requestParameters.acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiRuleGroupsGet: async (
      deleted?: boolean,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/RuleGroups`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (deleted !== undefined) {
        localVarQueryParameter["deleted"] = deleted;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: rulegroups_delete
     * @summary Delete rule groups by id
     * @param {string} requestParameters.id
     * @param {string} [requestParameters.apiVersion] The requested API version
     * @param {string} [requestParameters.acceptLanguage]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    userApiRuleGroupsIdDelete: async (
      id: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("userApiRuleGroupsIdDelete", "id", id);
      const localVarPath = `/UserApi/RuleGroups/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: rulegroups_read
     * @summary Get rule groups by id
     * @param {string} requestParameters.id
     * @param {string} [requestParameters.apiVersion] The requested API version
     * @param {string} [requestParameters.acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiRuleGroupsIdGet: async (
      id: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("userApiRuleGroupsIdGet", "id", id);
      const localVarPath = `/UserApi/RuleGroups/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: rulegroups_create
     * @summary Create or edit rule groups
     * @param {string} requestParameters.id
     * @param {string} [requestParameters.apiVersion] The requested API version
     * @param {string} [requestParameters.acceptLanguage]
     * @param {IRuleGroupVm} [requestParameters.iRuleGroupVm]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    userApiRuleGroupsIdPut: async (
      id: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iRuleGroupVm?: IRuleGroupVm,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("userApiRuleGroupsIdPut", "id", id);
      const localVarPath = `/UserApi/RuleGroups/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        iRuleGroupVm,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: rulegroups_create
     * @summary Create rule groups
     * @param {string} [requestParameters.apiVersion] The requested API version
     * @param {string} [requestParameters.acceptLanguage]
     * @param {IRuleGroupVm} [requestParameters.iRuleGroupVm]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    userApiRuleGroupsPost: async (
      apiVersion?: string,
      acceptLanguage?: string,
      iRuleGroupVm?: IRuleGroupVm,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/RuleGroups`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        iRuleGroupVm,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * RuleGroupsApi - functional programming interface
 * @export
 */
export const RuleGroupsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    RuleGroupsApiAxiosParamCreator(configuration);
  return {
    /**
     * Permission: rulegroups_read
     * Fp
     * @summary Get rule groups
     * @param {boolean} [deleted]
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiRuleGroupsGet(
      deleted?: boolean,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IRuleGroupListIRadianseResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiRuleGroupsGet(
          deleted,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },

    /**
     * Permission: rulegroups_delete
     * Fp
     * @summary Delete rule groups by id
     * @param {string} id
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async userApiRuleGroupsIdDelete(
      id: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IRuleGroupIRadianseResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiRuleGroupsIdDelete(
          id,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },

    /**
     * Permission: rulegroups_read
     * Fp
     * @summary Get rule groups by id
     * @param {string} id
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiRuleGroupsIdGet(
      id: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IRuleGroupIRadianseResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiRuleGroupsIdGet(
          id,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },

    /**
     * Permission: rulegroups_create
     * Fp
     * @summary Create or edit rule groups
     * @param {string} id
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IRuleGroupVm} [iRuleGroupVm]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async userApiRuleGroupsIdPut(
      id: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iRuleGroupVm?: IRuleGroupVm,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IRuleGroupIRadianseResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiRuleGroupsIdPut(
          id,
          apiVersion,
          acceptLanguage,
          iRuleGroupVm,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },

    /**
     * Permission: rulegroups_create
     * Fp
     * @summary Create rule groups
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IRuleGroupVm} [iRuleGroupVm]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async userApiRuleGroupsPost(
      apiVersion?: string,
      acceptLanguage?: string,
      iRuleGroupVm?: IRuleGroupVm,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IRuleGroupIRadianseResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiRuleGroupsPost(
          apiVersion,
          acceptLanguage,
          iRuleGroupVm,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * RuleGroupsApi - factory interface
 * @export
 */
export const RuleGroupsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = RuleGroupsApiFp(configuration);
  return {
    /**
     * Permission: rulegroups_read
     * Factory
     * @summary Get rule groups
     * @param {boolean} [deleted]
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiRuleGroupsGet(
      deleted?: boolean,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IRuleGroupListIRadianseResult> {
      return localVarFp
        .userApiRuleGroupsGet(deleted, apiVersion, acceptLanguage, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: rulegroups_delete
     * Factory
     * @summary Delete rule groups by id
     * @param {string} id
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    userApiRuleGroupsIdDelete(
      id: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IRuleGroupIRadianseResult> {
      return localVarFp
        .userApiRuleGroupsIdDelete(id, apiVersion, acceptLanguage, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: rulegroups_read
     * Factory
     * @summary Get rule groups by id
     * @param {string} id
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiRuleGroupsIdGet(
      id: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IRuleGroupIRadianseResult> {
      return localVarFp
        .userApiRuleGroupsIdGet(id, apiVersion, acceptLanguage, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: rulegroups_create
     * Factory
     * @summary Create or edit rule groups
     * @param {string} id
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IRuleGroupVm} [iRuleGroupVm]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    userApiRuleGroupsIdPut(
      id: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iRuleGroupVm?: IRuleGroupVm,
      options?: any
    ): AxiosPromise<IRuleGroupIRadianseResult> {
      return localVarFp
        .userApiRuleGroupsIdPut(
          id,
          apiVersion,
          acceptLanguage,
          iRuleGroupVm,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: rulegroups_create
     * Factory
     * @summary Create rule groups
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IRuleGroupVm} [iRuleGroupVm]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    userApiRuleGroupsPost(
      apiVersion?: string,
      acceptLanguage?: string,
      iRuleGroupVm?: IRuleGroupVm,
      options?: any
    ): AxiosPromise<IRuleGroupIRadianseResult> {
      return localVarFp
        .userApiRuleGroupsPost(
          apiVersion,
          acceptLanguage,
          iRuleGroupVm,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * RuleGroupsApi - object-oriented interface
 * @export
 * @class RuleGroupsApi
 * @extends {BaseAPI}
 */
export class RuleGroupsApi extends BaseAPI {
  /**
   * Permission: rulegroups_read
   * --TEST
   * @summary Get rule groups
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RuleGroupsApi
   */
  public userApiRuleGroupsGet(
    deleted?: boolean,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return RuleGroupsApiFp(this.configuration)
      .userApiRuleGroupsGet(deleted, apiVersion, acceptLanguage, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: rulegroups_delete
   * --TEST
   * @summary Delete rule groups by id
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof RuleGroupsApi
   */
  public userApiRuleGroupsIdDelete(
    id: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return RuleGroupsApiFp(this.configuration)
      .userApiRuleGroupsIdDelete(id, apiVersion, acceptLanguage, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: rulegroups_read
   * --TEST
   * @summary Get rule groups by id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RuleGroupsApi
   */
  public userApiRuleGroupsIdGet(
    id: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return RuleGroupsApiFp(this.configuration)
      .userApiRuleGroupsIdGet(id, apiVersion, acceptLanguage, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: rulegroups_create
   * --TEST
   * @summary Create or edit rule groups
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof RuleGroupsApi
   */
  public userApiRuleGroupsIdPut(
    id: string,
    apiVersion?: string,
    acceptLanguage?: string,
    iRuleGroupVm?: IRuleGroupVm,
    options?: AxiosRequestConfig
  ) {
    return RuleGroupsApiFp(this.configuration)
      .userApiRuleGroupsIdPut(
        id,
        apiVersion,
        acceptLanguage,
        iRuleGroupVm,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: rulegroups_create
   * --TEST
   * @summary Create rule groups
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof RuleGroupsApi
   */
  public userApiRuleGroupsPost(
    apiVersion?: string,
    acceptLanguage?: string,
    iRuleGroupVm?: IRuleGroupVm,
    options?: AxiosRequestConfig
  ) {
    return RuleGroupsApiFp(this.configuration)
      .userApiRuleGroupsPost(apiVersion, acceptLanguage, iRuleGroupVm, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * RuleManagerApi - axios parameter creator
 * @export
 */
export const RuleManagerApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Permission: ruleconfigurations_delete
     * @summary Delete a rule configuration and a CustomerConfiguration, TenantConfiguration, EventsConfiguration, or EquipmentConfiguration
     * @param {IElementRuleConfigType} requestParameters.elementType Customer, Tenant, Events, or Equipment
     * @param {string} requestParameters.id customerId, tenantId, eventsId, or equipmentId
     * @param {string} [requestParameters.groupId] If using group bearer token, groupId is required
     * @param {string} [requestParameters.tenantId] If using bearer token, tenantId is required
     * @param {string} [requestParameters.apiVersion] The requested API version
     * @param {string} [requestParameters.acceptLanguage]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    userApiRuleManagerRuleConfigurationsElementTypeIdDelete: async (
      elementType: IElementRuleConfigType,
      id: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'elementType' is not null or undefined
      assertParamExists(
        "userApiRuleManagerRuleConfigurationsElementTypeIdDelete",
        "elementType",
        elementType
      );
      // verify required parameter 'id' is not null or undefined
      assertParamExists(
        "userApiRuleManagerRuleConfigurationsElementTypeIdDelete",
        "id",
        id
      );
      const localVarPath =
        `/UserApi/RuleManager/RuleConfigurations/{elementType}/{id}`
          .replace(
            `{${"elementType"}}`,
            encodeURIComponent(String(elementType))
          )
          .replace(`{${"id"}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: ruleconfigurations_create
     * @summary Create or edit a rule configuration and add it to a CustomerConfiguration, TenantConfiguration, EventsConfiguration, or EquipmentConfiguration
     * @param {IElementRuleConfigType} requestParameters.elementType Customer, Tenant, Events, or Equipment
     * @param {string} requestParameters.id customerId, tenantId, eventsId, or equipmentId
     * @param {string} [requestParameters.tenantId] If using bearer token, tenantId is required when creating a configuration for events or equipment
     * @param {string} [requestParameters.apiVersion] The requested API version
     * @param {string} [requestParameters.acceptLanguage]
     * @param {IRuleConfigurationVm} [requestParameters.iRuleConfigurationVm]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    userApiRuleManagerRuleConfigurationsElementTypeIdPut: async (
      elementType: IElementRuleConfigType,
      id: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iRuleConfigurationVm?: IRuleConfigurationVm,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'elementType' is not null or undefined
      assertParamExists(
        "userApiRuleManagerRuleConfigurationsElementTypeIdPut",
        "elementType",
        elementType
      );
      // verify required parameter 'id' is not null or undefined
      assertParamExists(
        "userApiRuleManagerRuleConfigurationsElementTypeIdPut",
        "id",
        id
      );
      const localVarPath =
        `/UserApi/RuleManager/RuleConfigurations/{elementType}/{id}`
          .replace(
            `{${"elementType"}}`,
            encodeURIComponent(String(elementType))
          )
          .replace(`{${"id"}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        iRuleConfigurationVm,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: ruleconfigurations_delete
     * @summary Delete rule configuration and a CustomerConfiguration, TenantConfiguration, EventsConfiguration, or EquipmentConfiguration for all stages
     * @param {IElementRuleConfigType} requestParameters.elementType Customer, Tenant, Events, or Equipment
     * @param {string} requestParameters.id customerId, tenantId, eventsId, or equipmentId
     * @param {string} [requestParameters.groupId] If using group bearer token, groupId is required
     * @param {string} [requestParameters.tenantId] If using bearer token, tenantId is required
     * @param {string} [requestParameters.apiVersion] The requested API version
     * @param {string} [requestParameters.acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiRuleManagerRuleConfigurationsStagesElementTypeIdDelete: async (
      elementType: IElementRuleConfigType,
      id: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'elementType' is not null or undefined
      assertParamExists(
        "userApiRuleManagerRuleConfigurationsStagesElementTypeIdDelete",
        "elementType",
        elementType
      );
      // verify required parameter 'id' is not null or undefined
      assertParamExists(
        "userApiRuleManagerRuleConfigurationsStagesElementTypeIdDelete",
        "id",
        id
      );
      const localVarPath =
        `/UserApi/RuleManager/RuleConfigurations/Stages/{elementType}/{id}`
          .replace(
            `{${"elementType"}}`,
            encodeURIComponent(String(elementType))
          )
          .replace(`{${"id"}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: ruleconfigurations_create              If a stage is sent with null, the stage will be removed. For example:  \"Activation\": null.
     * @summary Create or edit a rule configurations for multiple stages and add it to a CustomerConfiguration, TenantConfiguration, EventsConfiguration, or EquipmentConfiguration
     * @param {IElementRuleConfigType} requestParameters.elementType Customer, Tenant, Events, or Equipment
     * @param {string} requestParameters.id customerId, tenantId, eventsId, or equipmentId
     * @param {string} [requestParameters.groupId] If using bearer token, groupId is required when creating a configuration for events or equipment
     * @param {string} [requestParameters.tenantId] If using bearer token, tenantId is required when creating a configuration for events or equipment
     * @param {string} [requestParameters.apiVersion] The requested API version
     * @param {string} [requestParameters.acceptLanguage]
     * @param {IRuleConfigurationStagesVm} [requestParameters.iRuleConfigurationStagesVm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiRuleManagerRuleConfigurationsStagesElementTypeIdPut: async (
      elementType: IElementRuleConfigType,
      id: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iRuleConfigurationStagesVm?: IRuleConfigurationStagesVm,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'elementType' is not null or undefined
      assertParamExists(
        "userApiRuleManagerRuleConfigurationsStagesElementTypeIdPut",
        "elementType",
        elementType
      );
      // verify required parameter 'id' is not null or undefined
      assertParamExists(
        "userApiRuleManagerRuleConfigurationsStagesElementTypeIdPut",
        "id",
        id
      );
      const localVarPath =
        `/UserApi/RuleManager/RuleConfigurations/Stages/{elementType}/{id}`
          .replace(
            `{${"elementType"}}`,
            encodeURIComponent(String(elementType))
          )
          .replace(`{${"id"}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        iRuleConfigurationStagesVm,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * RuleManagerApi - functional programming interface
 * @export
 */
export const RuleManagerApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    RuleManagerApiAxiosParamCreator(configuration);
  return {
    /**
     * Permission: ruleconfigurations_delete
     * Fp
     * @summary Delete a rule configuration and a CustomerConfiguration, TenantConfiguration, EventsConfiguration, or EquipmentConfiguration
     * @param {IElementRuleConfigType} elementType Customer, Tenant, Events, or Equipment
     * @param {string} id customerId, tenantId, eventsId, or equipmentId
     * @param {string} [groupId] If using group bearer token, groupId is required
     * @param {string} [tenantId] If using bearer token, tenantId is required
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async userApiRuleManagerRuleConfigurationsElementTypeIdDelete(
      elementType: IElementRuleConfigType,
      id: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IRequirementTypeIRadianseResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiRuleManagerRuleConfigurationsElementTypeIdDelete(
          elementType,
          id,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },

    /**
     * Permission: ruleconfigurations_create
     * Fp
     * @summary Create or edit a rule configuration and add it to a CustomerConfiguration, TenantConfiguration, EventsConfiguration, or EquipmentConfiguration
     * @param {IElementRuleConfigType} elementType Customer, Tenant, Events, or Equipment
     * @param {string} id customerId, tenantId, eventsId, or equipmentId
     * @param {string} [tenantId] If using bearer token, tenantId is required when creating a configuration for events or equipment
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IRuleConfigurationVm} [iRuleConfigurationVm]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async userApiRuleManagerRuleConfigurationsElementTypeIdPut(
      elementType: IElementRuleConfigType,
      id: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iRuleConfigurationVm?: IRuleConfigurationVm,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IRequirementTypeIRadianseResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiRuleManagerRuleConfigurationsElementTypeIdPut(
          elementType,
          id,
          tenantId,
          apiVersion,
          acceptLanguage,
          iRuleConfigurationVm,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },

    /**
     * Permission: ruleconfigurations_delete
     * Fp
     * @summary Delete rule configuration and a CustomerConfiguration, TenantConfiguration, EventsConfiguration, or EquipmentConfiguration for all stages
     * @param {IElementRuleConfigType} elementType Customer, Tenant, Events, or Equipment
     * @param {string} id customerId, tenantId, eventsId, or equipmentId
     * @param {string} [groupId] If using group bearer token, groupId is required
     * @param {string} [tenantId] If using bearer token, tenantId is required
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiRuleManagerRuleConfigurationsStagesElementTypeIdDelete(
      elementType: IElementRuleConfigType,
      id: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IRuleStageTypeStringDictionaryIRadianseResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiRuleManagerRuleConfigurationsStagesElementTypeIdDelete(
          elementType,
          id,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },

    /**
     * Permission: ruleconfigurations_create              If a stage is sent with null, the stage will be removed. For example:  \"Activation\": null.
     * Fp
     * @summary Create or edit a rule configurations for multiple stages and add it to a CustomerConfiguration, TenantConfiguration, EventsConfiguration, or EquipmentConfiguration
     * @param {IElementRuleConfigType} elementType Customer, Tenant, Events, or Equipment
     * @param {string} id customerId, tenantId, eventsId, or equipmentId
     * @param {string} [groupId] If using bearer token, groupId is required when creating a configuration for events or equipment
     * @param {string} [tenantId] If using bearer token, tenantId is required when creating a configuration for events or equipment
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IRuleConfigurationStagesVm} [iRuleConfigurationStagesVm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiRuleManagerRuleConfigurationsStagesElementTypeIdPut(
      elementType: IElementRuleConfigType,
      id: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iRuleConfigurationStagesVm?: IRuleConfigurationStagesVm,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IRuleStageTypeStringDictionaryIRadianseResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiRuleManagerRuleConfigurationsStagesElementTypeIdPut(
          elementType,
          id,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          iRuleConfigurationStagesVm,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * RuleManagerApi - factory interface
 * @export
 */
export const RuleManagerApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = RuleManagerApiFp(configuration);
  return {
    /**
     * Permission: ruleconfigurations_delete
     * Factory
     * @summary Delete a rule configuration and a CustomerConfiguration, TenantConfiguration, EventsConfiguration, or EquipmentConfiguration
     * @param {IElementRuleConfigType} elementType Customer, Tenant, Events, or Equipment
     * @param {string} id customerId, tenantId, eventsId, or equipmentId
     * @param {string} [groupId] If using group bearer token, groupId is required
     * @param {string} [tenantId] If using bearer token, tenantId is required
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    userApiRuleManagerRuleConfigurationsElementTypeIdDelete(
      elementType: IElementRuleConfigType,
      id: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IRequirementTypeIRadianseResult> {
      return localVarFp
        .userApiRuleManagerRuleConfigurationsElementTypeIdDelete(
          elementType,
          id,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: ruleconfigurations_create
     * Factory
     * @summary Create or edit a rule configuration and add it to a CustomerConfiguration, TenantConfiguration, EventsConfiguration, or EquipmentConfiguration
     * @param {IElementRuleConfigType} elementType Customer, Tenant, Events, or Equipment
     * @param {string} id customerId, tenantId, eventsId, or equipmentId
     * @param {string} [tenantId] If using bearer token, tenantId is required when creating a configuration for events or equipment
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IRuleConfigurationVm} [iRuleConfigurationVm]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    userApiRuleManagerRuleConfigurationsElementTypeIdPut(
      elementType: IElementRuleConfigType,
      id: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iRuleConfigurationVm?: IRuleConfigurationVm,
      options?: any
    ): AxiosPromise<IRequirementTypeIRadianseResult> {
      return localVarFp
        .userApiRuleManagerRuleConfigurationsElementTypeIdPut(
          elementType,
          id,
          tenantId,
          apiVersion,
          acceptLanguage,
          iRuleConfigurationVm,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: ruleconfigurations_delete
     * Factory
     * @summary Delete rule configuration and a CustomerConfiguration, TenantConfiguration, EventsConfiguration, or EquipmentConfiguration for all stages
     * @param {IElementRuleConfigType} elementType Customer, Tenant, Events, or Equipment
     * @param {string} id customerId, tenantId, eventsId, or equipmentId
     * @param {string} [groupId] If using group bearer token, groupId is required
     * @param {string} [tenantId] If using bearer token, tenantId is required
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiRuleManagerRuleConfigurationsStagesElementTypeIdDelete(
      elementType: IElementRuleConfigType,
      id: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IRuleStageTypeStringDictionaryIRadianseResult> {
      return localVarFp
        .userApiRuleManagerRuleConfigurationsStagesElementTypeIdDelete(
          elementType,
          id,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: ruleconfigurations_create              If a stage is sent with null, the stage will be removed. For example:  \"Activation\": null.
     * Factory
     * @summary Create or edit a rule configurations for multiple stages and add it to a CustomerConfiguration, TenantConfiguration, EventsConfiguration, or EquipmentConfiguration
     * @param {IElementRuleConfigType} elementType Customer, Tenant, Events, or Equipment
     * @param {string} id customerId, tenantId, eventsId, or equipmentId
     * @param {string} [groupId] If using bearer token, groupId is required when creating a configuration for events or equipment
     * @param {string} [tenantId] If using bearer token, tenantId is required when creating a configuration for events or equipment
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IRuleConfigurationStagesVm} [iRuleConfigurationStagesVm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiRuleManagerRuleConfigurationsStagesElementTypeIdPut(
      elementType: IElementRuleConfigType,
      id: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iRuleConfigurationStagesVm?: IRuleConfigurationStagesVm,
      options?: any
    ): AxiosPromise<IRuleStageTypeStringDictionaryIRadianseResult> {
      return localVarFp
        .userApiRuleManagerRuleConfigurationsStagesElementTypeIdPut(
          elementType,
          id,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          iRuleConfigurationStagesVm,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * RuleManagerApi - object-oriented interface
 * @export
 * @class RuleManagerApi
 * @extends {BaseAPI}
 */
export class RuleManagerApi extends BaseAPI {
  /**
   * Permission: ruleconfigurations_delete
   * --TEST
   * @summary Delete a rule configuration and a CustomerConfiguration, TenantConfiguration, EventsConfiguration, or EquipmentConfiguration
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof RuleManagerApi
   */
  public userApiRuleManagerRuleConfigurationsElementTypeIdDelete(
    elementType: IElementRuleConfigType,
    id: string,
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return RuleManagerApiFp(this.configuration)
      .userApiRuleManagerRuleConfigurationsElementTypeIdDelete(
        elementType,
        id,
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: ruleconfigurations_create
   * --TEST
   * @summary Create or edit a rule configuration and add it to a CustomerConfiguration, TenantConfiguration, EventsConfiguration, or EquipmentConfiguration
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof RuleManagerApi
   */
  public userApiRuleManagerRuleConfigurationsElementTypeIdPut(
    elementType: IElementRuleConfigType,
    id: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    iRuleConfigurationVm?: IRuleConfigurationVm,
    options?: AxiosRequestConfig
  ) {
    return RuleManagerApiFp(this.configuration)
      .userApiRuleManagerRuleConfigurationsElementTypeIdPut(
        elementType,
        id,
        tenantId,
        apiVersion,
        acceptLanguage,
        iRuleConfigurationVm,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: ruleconfigurations_delete
   * --TEST
   * @summary Delete rule configuration and a CustomerConfiguration, TenantConfiguration, EventsConfiguration, or EquipmentConfiguration for all stages
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RuleManagerApi
   */
  public userApiRuleManagerRuleConfigurationsStagesElementTypeIdDelete(
    elementType: IElementRuleConfigType,
    id: string,
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return RuleManagerApiFp(this.configuration)
      .userApiRuleManagerRuleConfigurationsStagesElementTypeIdDelete(
        elementType,
        id,
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: ruleconfigurations_create              If a stage is sent with null, the stage will be removed. For example:  \"Activation\": null.
   * --TEST
   * @summary Create or edit a rule configurations for multiple stages and add it to a CustomerConfiguration, TenantConfiguration, EventsConfiguration, or EquipmentConfiguration
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RuleManagerApi
   */
  public userApiRuleManagerRuleConfigurationsStagesElementTypeIdPut(
    elementType: IElementRuleConfigType,
    id: string,
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    iRuleConfigurationStagesVm?: IRuleConfigurationStagesVm,
    options?: AxiosRequestConfig
  ) {
    return RuleManagerApiFp(this.configuration)
      .userApiRuleManagerRuleConfigurationsStagesElementTypeIdPut(
        elementType,
        id,
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        iRuleConfigurationStagesVm,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * TenantConfigurationsApi - axios parameter creator
 * @export
 */
export const TenantConfigurationsApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Permission: tenantconfigurations_delete
     * @summary Delete tenant configurations
     * @param {IRuleStageType} [requestParameters.stage]
     * @param {string} [requestParameters.tenantId] TenantId is required if using a bearer token.
     * @param {string} [requestParameters.apiVersion] The requested API version
     * @param {string} [requestParameters.acceptLanguage]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    userApiTenantConfigurationsDelete: async (
      stage?: IRuleStageType,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/TenantConfigurations`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (stage !== undefined) {
        localVarQueryParameter["stage"] = stage;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: tenantconfigurations_read
     * @summary Get tenant configurations
     * @param {IClientTreeType} [requestParameters.clientTreeType] Customer: Get all on customer. Group: Get all for group. Tenant: Get all for tenant
     * @param {boolean} [requestParameters.deleted] null: get all, true: get deleted, false: get active
     * @param {string} [requestParameters.groupId]
     * @param {string} [requestParameters.tenantId] TenantId is required if using a bearer token.
     * @param {string} [requestParameters.apiVersion] The requested API version
     * @param {string} [requestParameters.acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiTenantConfigurationsGet: async (
      clientTreeType?: IClientTreeType,
      deleted?: boolean,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/TenantConfigurations`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (clientTreeType !== undefined) {
        localVarQueryParameter["clientTreeType"] = clientTreeType;
      }

      if (deleted !== undefined) {
        localVarQueryParameter["deleted"] = deleted;
      }

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: tenantconfigurations_read
     * @summary Get tenant configurations by TenantId. TenantId is taken from authentication
     * @param {IRuleStageType} [requestParameters.stage]
     * @param {string} [requestParameters.tenantId] TenantId is required if using a bearer token.
     * @param {string} [requestParameters.apiVersion] The requested API version
     * @param {string} [requestParameters.acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiTenantConfigurationsIdGet: async (
      stage?: IRuleStageType,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/TenantConfigurations/id`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (stage !== undefined) {
        localVarQueryParameter["stage"] = stage;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: tenantconfigurations_create              <br>Id used is the tenantId
     * @summary Create or update tenant configurations
     * @param {string} [requestParameters.tenantId] TenantId is required if using a bearer token.
     * @param {string} [requestParameters.apiVersion] The requested API version
     * @param {string} [requestParameters.acceptLanguage]
     * @param {IElementConfigurationVm} [requestParameters.iElementConfigurationVm]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    userApiTenantConfigurationsPut: async (
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iElementConfigurationVm?: IElementConfigurationVm,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/TenantConfigurations`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        iElementConfigurationVm,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * TenantConfigurationsApi - functional programming interface
 * @export
 */
export const TenantConfigurationsApiFp = function (
  configuration?: Configuration
) {
  const localVarAxiosParamCreator =
    TenantConfigurationsApiAxiosParamCreator(configuration);
  return {
    /**
     * Permission: tenantconfigurations_delete
     * Fp
     * @summary Delete tenant configurations
     * @param {IRuleStageType} [stage]
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async userApiTenantConfigurationsDelete(
      stage?: IRuleStageType,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<ITenantConfigurationIRadianseResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiTenantConfigurationsDelete(
          stage,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },

    /**
     * Permission: tenantconfigurations_read
     * Fp
     * @summary Get tenant configurations
     * @param {IClientTreeType} [clientTreeType] Customer: Get all on customer. Group: Get all for group. Tenant: Get all for tenant
     * @param {boolean} [deleted] null: get all, true: get deleted, false: get active
     * @param {string} [groupId]
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiTenantConfigurationsGet(
      clientTreeType?: IClientTreeType,
      deleted?: boolean,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<ITenantConfigurationIEnumerableIRadianseResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiTenantConfigurationsGet(
          clientTreeType,
          deleted,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },

    /**
     * Permission: tenantconfigurations_read
     * Fp
     * @summary Get tenant configurations by TenantId. TenantId is taken from authentication
     * @param {IRuleStageType} [stage]
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiTenantConfigurationsIdGet(
      stage?: IRuleStageType,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<ITenantConfigurationIRadianseResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiTenantConfigurationsIdGet(
          stage,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },

    /**
     * Permission: tenantconfigurations_create              <br>Id used is the tenantId
     * Fp
     * @summary Create or update tenant configurations
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IElementConfigurationVm} [iElementConfigurationVm]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async userApiTenantConfigurationsPut(
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iElementConfigurationVm?: IElementConfigurationVm,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<ITenantConfigurationIRadianseResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiTenantConfigurationsPut(
          tenantId,
          apiVersion,
          acceptLanguage,
          iElementConfigurationVm,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * TenantConfigurationsApi - factory interface
 * @export
 */
export const TenantConfigurationsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = TenantConfigurationsApiFp(configuration);
  return {
    /**
     * Permission: tenantconfigurations_delete
     * Factory
     * @summary Delete tenant configurations
     * @param {IRuleStageType} [stage]
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    userApiTenantConfigurationsDelete(
      stage?: IRuleStageType,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<ITenantConfigurationIRadianseResult> {
      return localVarFp
        .userApiTenantConfigurationsDelete(
          stage,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: tenantconfigurations_read
     * Factory
     * @summary Get tenant configurations
     * @param {IClientTreeType} [clientTreeType] Customer: Get all on customer. Group: Get all for group. Tenant: Get all for tenant
     * @param {boolean} [deleted] null: get all, true: get deleted, false: get active
     * @param {string} [groupId]
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiTenantConfigurationsGet(
      clientTreeType?: IClientTreeType,
      deleted?: boolean,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<ITenantConfigurationIEnumerableIRadianseResult> {
      return localVarFp
        .userApiTenantConfigurationsGet(
          clientTreeType,
          deleted,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: tenantconfigurations_read
     * Factory
     * @summary Get tenant configurations by TenantId. TenantId is taken from authentication
     * @param {IRuleStageType} [stage]
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiTenantConfigurationsIdGet(
      stage?: IRuleStageType,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<ITenantConfigurationIRadianseResult> {
      return localVarFp
        .userApiTenantConfigurationsIdGet(
          stage,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: tenantconfigurations_create              <br>Id used is the tenantId
     * Factory
     * @summary Create or update tenant configurations
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IElementConfigurationVm} [iElementConfigurationVm]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    userApiTenantConfigurationsPut(
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iElementConfigurationVm?: IElementConfigurationVm,
      options?: any
    ): AxiosPromise<ITenantConfigurationIRadianseResult> {
      return localVarFp
        .userApiTenantConfigurationsPut(
          tenantId,
          apiVersion,
          acceptLanguage,
          iElementConfigurationVm,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * TenantConfigurationsApi - object-oriented interface
 * @export
 * @class TenantConfigurationsApi
 * @extends {BaseAPI}
 */
export class TenantConfigurationsApi extends BaseAPI {
  /**
   * Permission: tenantconfigurations_delete
   * --TEST
   * @summary Delete tenant configurations
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof TenantConfigurationsApi
   */
  public userApiTenantConfigurationsDelete(
    stage?: IRuleStageType,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return TenantConfigurationsApiFp(this.configuration)
      .userApiTenantConfigurationsDelete(
        stage,
        tenantId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: tenantconfigurations_read
   * --TEST
   * @summary Get tenant configurations
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TenantConfigurationsApi
   */
  public userApiTenantConfigurationsGet(
    clientTreeType?: IClientTreeType,
    deleted?: boolean,
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return TenantConfigurationsApiFp(this.configuration)
      .userApiTenantConfigurationsGet(
        clientTreeType,
        deleted,
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: tenantconfigurations_read
   * --TEST
   * @summary Get tenant configurations by TenantId. TenantId is taken from authentication
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TenantConfigurationsApi
   */
  public userApiTenantConfigurationsIdGet(
    stage?: IRuleStageType,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return TenantConfigurationsApiFp(this.configuration)
      .userApiTenantConfigurationsIdGet(
        stage,
        tenantId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: tenantconfigurations_create              <br>Id used is the tenantId
   * --TEST
   * @summary Create or update tenant configurations
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof TenantConfigurationsApi
   */
  public userApiTenantConfigurationsPut(
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    iElementConfigurationVm?: IElementConfigurationVm,
    options?: AxiosRequestConfig
  ) {
    return TenantConfigurationsApiFp(this.configuration)
      .userApiTenantConfigurationsPut(
        tenantId,
        apiVersion,
        acceptLanguage,
        iElementConfigurationVm,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}
